var items = {
  "block.minecraft.acacia_button": "Akazienholzknäppchen",
  "block.minecraft.acacia_door": "Akazienholzdier",
  "block.minecraft.acacia_fence": "Akazienholzzonk",
  "block.minecraft.acacia_fence_gate": "Akazienholzzonkpaart",
  "block.minecraft.acacia_hanging_sign": "Akazienholzhängeschëld",
  "block.minecraft.acacia_leaves": "Akazieblieder",
  "block.minecraft.acacia_log": "Akaziëstamm",
  "block.minecraft.acacia_planks": "Akazienholzbrieder",
  "block.minecraft.acacia_pressure_plate": "Akazienholzdrockplack",
  "block.minecraft.acacia_sapling": "Akaziesetzlek",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Akazienholzschëld",
  "block.minecraft.acacia_slab": "Akazienholzplack",
  "block.minecraft.acacia_stairs": "Akazienholztrap",
  "block.minecraft.acacia_trapdoor": "Akazienholzklappdier",
  "block.minecraft.acacia_wall_hanging_sign": "Akazienhängeschëld",
  "block.minecraft.acacia_wall_sign": "Akazienholzmauerschëld",
  "block.minecraft.acacia_wood": "Akazienholz",
  "block.minecraft.activator_rail": "Aktivéierungsschinn",
  "block.minecraft.air": "Loft",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Amethystblock",
  "block.minecraft.amethyst_cluster": "Amethystkoup",
  "block.minecraft.ancient_debris": "Anticke Schrott",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitplack",
  "block.minecraft.andesite_stairs": "Andesittrap",
  "block.minecraft.andesite_wall": "Andesitmauer",
  "block.minecraft.anvil": "Amboss",
  "block.minecraft.attached_melon_stem": "Attachéierte Melounestill",
  "block.minecraft.attached_pumpkin_stem": "Kürbisstill",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleëblieder",
  "block.minecraft.azure_bluet": "Porzeläinsstäerchen",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambusknäppchen",
  "block.minecraft.bamboo_door": "Bambusdier",
  "block.minecraft.bamboo_fence": "Bambuszonk",
  "block.minecraft.bamboo_fence_gate": "Bambuszonkpaart",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschëld",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikplack",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktrap",
  "block.minecraft.bamboo_planks": "Bambusbrieder",
  "block.minecraft.bamboo_pressure_plate": "Bambusdrockplack",
  "block.minecraft.bamboo_sapling": "Bambusschoss",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bambusschëld",
  "block.minecraft.bamboo_slab": "Bambusplack",
  "block.minecraft.bamboo_stairs": "Bambustrap",
  "block.minecraft.bamboo_trapdoor": "Bambusklappdier",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschëld",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschëld",
  "block.minecraft.banner.base.black": "Komplett schwaarzt Feld",
  "block.minecraft.banner.base.blue": "Komplett blot Feld",
  "block.minecraft.banner.base.brown": "Komplett brongt Feld",
  "block.minecraft.banner.base.cyan": "Komplett turquoiset Feld",
  "block.minecraft.banner.base.gray": "Komplett grot Feld",
  "block.minecraft.banner.base.green": "Komplett gréngt Feld",
  "block.minecraft.banner.base.light_blue": "Komplett hellblot Feld",
  "block.minecraft.banner.base.light_gray": "Komplett hellgrot Feld",
  "block.minecraft.banner.base.lime": "Komplett hellgréngt Feld",
  "block.minecraft.banner.base.magenta": "Komplett magentat Feld",
  "block.minecraft.banner.base.orange": "Komplett oranget Feld",
  "block.minecraft.banner.base.pink": "Komplett rosat Feld",
  "block.minecraft.banner.base.purple": "Komplett mooft Feld",
  "block.minecraft.banner.base.red": "Komplett rout Feld",
  "block.minecraft.banner.base.white": "Komplett wäisst Feld",
  "block.minecraft.banner.base.yellow": "Komplett gielt Feld",
  "block.minecraft.banner.border.black": "Schwaarz Bordure",
  "block.minecraft.banner.border.blue": "Blo Bordure",
  "block.minecraft.banner.border.brown": "Brong Bordure",
  "block.minecraft.banner.border.cyan": "Turquoise Bordure",
  "block.minecraft.banner.border.gray": "Gro Bordure",
  "block.minecraft.banner.border.green": "Gréng Bordure",
  "block.minecraft.banner.border.light_blue": "Hellblo Bordure",
  "block.minecraft.banner.border.light_gray": "Hellgro Bordure",
  "block.minecraft.banner.border.lime": "Hellgréng Bordure",
  "block.minecraft.banner.border.magenta": "Magenta Bordure",
  "block.minecraft.banner.border.orange": "Orange Bordure",
  "block.minecraft.banner.border.pink": "Rosa Bordure",
  "block.minecraft.banner.border.purple": "Mof Bordure",
  "block.minecraft.banner.border.red": "Rout Bordure",
  "block.minecraft.banner.border.white": "Wäiss Bordure",
  "block.minecraft.banner.border.yellow": "Giel Bordure",
  "block.minecraft.banner.bricks.black": "Feld schwaarz gemauert",
  "block.minecraft.banner.bricks.blue": "Feld blo gemauert",
  "block.minecraft.banner.bricks.brown": "Feld brong gemauert",
  "block.minecraft.banner.bricks.cyan": "Feld turquoise gemauert",
  "block.minecraft.banner.bricks.gray": "Feld gro gemauert",
  "block.minecraft.banner.bricks.green": "Feld gréng gemauert",
  "block.minecraft.banner.bricks.light_blue": "Feld hellblo gemauert",
  "block.minecraft.banner.bricks.light_gray": "Feld hellgro gemauert",
  "block.minecraft.banner.bricks.lime": "Feld hellgréng gemauert",
  "block.minecraft.banner.bricks.magenta": "Feld magenta gemauert",
  "block.minecraft.banner.bricks.orange": "Feld orange gemauert",
  "block.minecraft.banner.bricks.pink": "Feld rosa gemauert",
  "block.minecraft.banner.bricks.purple": "Feld mof gemauert",
  "block.minecraft.banner.bricks.red": "Feld rout gemauert",
  "block.minecraft.banner.bricks.white": "Feld wäiss gemauert",
  "block.minecraft.banner.bricks.yellow": "Feld giel gemauert",
  "block.minecraft.banner.circle.black": "Schwaarz Kugel",
  "block.minecraft.banner.circle.blue": "Blo Kugel",
  "block.minecraft.banner.circle.brown": "Brong Kugel",
  "block.minecraft.banner.circle.cyan": "Turquoise Kugel",
  "block.minecraft.banner.circle.gray": "Gro Kugel",
  "block.minecraft.banner.circle.green": "Gréng Kugel",
  "block.minecraft.banner.circle.light_blue": "Hellblo Kugel",
  "block.minecraft.banner.circle.light_gray": "Hellgro Kugel",
  "block.minecraft.banner.circle.lime": "Hellgréng Kugel",
  "block.minecraft.banner.circle.magenta": "Magenta Kugel",
  "block.minecraft.banner.circle.orange": "Orange Kugel",
  "block.minecraft.banner.circle.pink": "Rosa Kugel",
  "block.minecraft.banner.circle.purple": "Mof Kugel",
  "block.minecraft.banner.circle.red": "Rout Kugel",
  "block.minecraft.banner.circle.white": "Wäiss Kugel",
  "block.minecraft.banner.circle.yellow": "Giel Kugel",
  "block.minecraft.banner.creeper.black": "Schwaarze Creeper",
  "block.minecraft.banner.creeper.blue": "Bloe Creeper",
  "block.minecraft.banner.creeper.brown": "Bronge Creeper",
  "block.minecraft.banner.creeper.cyan": "Turquoise Creeper",
  "block.minecraft.banner.creeper.gray": "Groe Creeper",
  "block.minecraft.banner.creeper.green": "Grénge Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellbloe Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgroe Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrénge Creeper",
  "block.minecraft.banner.creeper.magenta": "Magentae Creeper",
  "block.minecraft.banner.creeper.orange": "Orange Creeper",
  "block.minecraft.banner.creeper.pink": "Rosae Creeper",
  "block.minecraft.banner.creeper.purple": "Mofe Creeper",
  "block.minecraft.banner.creeper.red": "Roude Creeper",
  "block.minecraft.banner.creeper.white": "Wäisse Creeper",
  "block.minecraft.banner.creeper.yellow": "Giele Creeper",
  "block.minecraft.banner.cross.black": "Schwaarzt Andreaskräiz",
  "block.minecraft.banner.cross.blue": "Blot Andreaskräiz",
  "block.minecraft.banner.cross.brown": "Brongt Andreaskräiz",
  "block.minecraft.banner.cross.cyan": "Turquoiset Andreaskräiz",
  "block.minecraft.banner.cross.gray": "Grot Andreaskräiz",
  "block.minecraft.banner.cross.green": "Gréngt Andreaskräiz",
  "block.minecraft.banner.cross.light_blue": "Hellblot Andreaskräiz",
  "block.minecraft.banner.cross.light_gray": "Hellgrot Andreaskräiz",
  "block.minecraft.banner.cross.lime": "Hellgréngt Andreaskräiz",
  "block.minecraft.banner.cross.magenta": "Magentat Andreaskräiz",
  "block.minecraft.banner.cross.orange": "Oranget Andreaskräiz",
  "block.minecraft.banner.cross.pink": "Rosat Andreaskräiz",
  "block.minecraft.banner.cross.purple": "Moft Andreaskräiz",
  "block.minecraft.banner.cross.red": "Rout Andreaskräiz",
  "block.minecraft.banner.cross.white": "Wäisst Andreaskräiz",
  "block.minecraft.banner.cross.yellow": "Gielt Andreaskräiz",
  "block.minecraft.banner.curly_border.black": "Schwaarz gezackte Bordure",
  "block.minecraft.banner.curly_border.blue": "Blo gezackte Bordure",
  "block.minecraft.banner.curly_border.brown": "Brong gezackte Bordure",
  "block.minecraft.banner.curly_border.cyan": "Turquoise gezackte Bordure",
  "block.minecraft.banner.curly_border.gray": "Gro gezackte Bordure",
  "block.minecraft.banner.curly_border.green": "Gréng gezackte Bordure",
  "block.minecraft.banner.curly_border.light_blue": "Hellblo gezackte Bordure",
  "block.minecraft.banner.curly_border.light_gray": "Hellgro gezackte Bordure",
  "block.minecraft.banner.curly_border.lime": "Hellgréng gezackte Bordure",
  "block.minecraft.banner.curly_border.magenta": "Magenta gezackte Bordure",
  "block.minecraft.banner.curly_border.orange": "Orange gezackte Bordure",
  "block.minecraft.banner.curly_border.pink": "Rosa gezackte Bordure",
  "block.minecraft.banner.curly_border.purple": "Mof gezackte Bordure",
  "block.minecraft.banner.curly_border.red": "Rout gezackte Bordure",
  "block.minecraft.banner.curly_border.white": "Wäiss gezackte Bordure",
  "block.minecraft.banner.curly_border.yellow": "Giel gezackte Bordure",
  "block.minecraft.banner.diagonal_left.black": "Schwaarz queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.blue": "Blo queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.brown": "Brong queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.cyan": "Turquoise queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.gray": "Gro queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.green": "Gréng queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblo queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgro queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.lime": "Hellgréng queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.orange": "Orange queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.pink": "Rosa queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.purple": "Mof queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.red": "Rout queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.white": "Wäiss queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_left.yellow": "Giel queesch lénks gedeelt",
  "block.minecraft.banner.diagonal_right.black": "Schwaarz queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.blue": "Blo queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.brown": "Brong queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.cyan": "Turquoise queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.gray": "Gro queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.green": "Gréng queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblo queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgro queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.lime": "Hellgréng queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.orange": "Orange queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.pink": "Rosa queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.purple": "Mof queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.red": "Rout queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.white": "Wäiss queesch riets gedeelt",
  "block.minecraft.banner.diagonal_right.yellow": "Giel queesch riets gedeelt",
  "block.minecraft.banner.diagonal_up_left.black": "Schwaarz queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blo queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Brong queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turquoise queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Gro queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Gréng queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblo queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgro queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgréng queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Mof queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Rout queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Wäiss queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Giel queesch riets gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwaarz queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blo queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Brong queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turquoise queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Gro queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Gréng queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblo queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgro queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgréng queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Mof queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Rout queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Wäiss queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Giel queesch lénks gedeelt (Inverséiert)",
  "block.minecraft.banner.flow.black": "Schwaarze Floss",
  "block.minecraft.banner.flow.blue": "Bloe Floss",
  "block.minecraft.banner.flow.brown": "Bronge Floss",
  "block.minecraft.banner.flow.cyan": "Turquoise Floss",
  "block.minecraft.banner.flow.gray": "Groe Floss",
  "block.minecraft.banner.flow.green": "Grénge Floss",
  "block.minecraft.banner.flow.light_blue": "Hellbloe Floss",
  "block.minecraft.banner.flow.light_gray": "Hellgroe Floss",
  "block.minecraft.banner.flow.lime": "Hellgrénge Floss",
  "block.minecraft.banner.flow.magenta": "Magenta Floss",
  "block.minecraft.banner.flow.orange": "Orange Floss",
  "block.minecraft.banner.flow.pink": "Rosa Floss",
  "block.minecraft.banner.flow.purple": "Mofe Floss",
  "block.minecraft.banner.flow.red": "Roude Floss",
  "block.minecraft.banner.flow.white": "Wäisse Floss",
  "block.minecraft.banner.flow.yellow": "Giele Floss",
  "block.minecraft.banner.flower.black": "Schwaarz Blumm",
  "block.minecraft.banner.flower.blue": "Blo Blumm",
  "block.minecraft.banner.flower.brown": "Brong Blumm",
  "block.minecraft.banner.flower.cyan": "Turquoise Blumm",
  "block.minecraft.banner.flower.gray": "Gro Blumm",
  "block.minecraft.banner.flower.green": "Gréng Blumm",
  "block.minecraft.banner.flower.light_blue": "Hellblo Blumm",
  "block.minecraft.banner.flower.light_gray": "Hellgro Blumm",
  "block.minecraft.banner.flower.lime": "Hellgréng Blumm",
  "block.minecraft.banner.flower.magenta": "Magenta Blumm",
  "block.minecraft.banner.flower.orange": "Orange Blumm",
  "block.minecraft.banner.flower.pink": "Rosa Blumm",
  "block.minecraft.banner.flower.purple": "Mof Blumm",
  "block.minecraft.banner.flower.red": "Rout Blumm",
  "block.minecraft.banner.flower.white": "Wäiss Blumm",
  "block.minecraft.banner.flower.yellow": "Giel Blumm",
  "block.minecraft.banner.globe.black": "Schwaarze Globus",
  "block.minecraft.banner.globe.blue": "Bloe Globus",
  "block.minecraft.banner.globe.brown": "Bronge Globus",
  "block.minecraft.banner.globe.cyan": "Turquoise Globus",
  "block.minecraft.banner.globe.gray": "Groe Globus",
  "block.minecraft.banner.globe.green": "Grénge Globus",
  "block.minecraft.banner.globe.light_blue": "Hellbloe Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgroe Globus",
  "block.minecraft.banner.globe.lime": "Hellgrénge Globus",
  "block.minecraft.banner.globe.magenta": "Magentae Globus",
  "block.minecraft.banner.globe.orange": "Orange Globus",
  "block.minecraft.banner.globe.pink": "Rosae Globus",
  "block.minecraft.banner.globe.purple": "Mofe Globus",
  "block.minecraft.banner.globe.red": "Roude Globus",
  "block.minecraft.banner.globe.white": "Wäisse Globus",
  "block.minecraft.banner.globe.yellow": "Giele Globus",
  "block.minecraft.banner.gradient.black": "Schwaarze Fuerfverlaf",
  "block.minecraft.banner.gradient.blue": "Bloe Fuerfverlaf",
  "block.minecraft.banner.gradient.brown": "Bronge Fuerfverlaf",
  "block.minecraft.banner.gradient.cyan": "Turquoise Fuerfverlaf",
  "block.minecraft.banner.gradient.gray": "Groe Fuerfverlaf",
  "block.minecraft.banner.gradient.green": "Grénge Fuerfverlaf",
  "block.minecraft.banner.gradient.light_blue": "Hellbloe Fuerfverlaf",
  "block.minecraft.banner.gradient.light_gray": "Hellgroe Fuerfverlaf",
  "block.minecraft.banner.gradient.lime": "Hellgrénge Fuerfverlaf",
  "block.minecraft.banner.gradient.magenta": "Magentae Fuerfverlaf",
  "block.minecraft.banner.gradient.orange": "Orange Fuerfverlaf",
  "block.minecraft.banner.gradient.pink": "Rosae Fuerfverlaf",
  "block.minecraft.banner.gradient.purple": "Mofe Fuerfverlaf",
  "block.minecraft.banner.gradient.red": "Roude Fuerfverlaf",
  "block.minecraft.banner.gradient.white": "Wäisse Fuerfverlaf",
  "block.minecraft.banner.gradient.yellow": "Giele Fuerfverlaf",
  "block.minecraft.banner.gradient_up.black": "Schwaarze Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.blue": "Bloe Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.brown": "Bronge Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.cyan": "Turquoise Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.gray": "Groe Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.green": "Grénge Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellbloe Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgroe Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrénge Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magentae Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.orange": "Orange Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.pink": "Rosae Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.purple": "Mofe Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.red": "Roude Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.white": "Wäisse Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.gradient_up.yellow": "Giele Fuerfverlaf (Inverséiert)",
  "block.minecraft.banner.guster.black": "Schwaarze Wandstoussert",
  "block.minecraft.banner.guster.blue": "Bloe Wandstoussert",
  "block.minecraft.banner.guster.brown": "Bronge Wandstoussert",
  "block.minecraft.banner.guster.cyan": "Turquoise Wandstoussert",
  "block.minecraft.banner.guster.gray": "Groe Wandstoussert",
  "block.minecraft.banner.guster.green": "Grénge Wandstoussert",
  "block.minecraft.banner.guster.light_blue": "Hellbloe Wandstoussert",
  "block.minecraft.banner.guster.light_gray": "Hellgroe Wandstoussert",
  "block.minecraft.banner.guster.lime": "Hellgrénge Wandstoussert",
  "block.minecraft.banner.guster.magenta": "Magenta Wandstoussert",
  "block.minecraft.banner.guster.orange": "Orange Wandstoussert",
  "block.minecraft.banner.guster.pink": "Rosa Wandstoussert",
  "block.minecraft.banner.guster.purple": "Mofe Wandstoussert",
  "block.minecraft.banner.guster.red": "Roude Wandstoussert",
  "block.minecraft.banner.guster.white": "Wäisse Wandstoussert",
  "block.minecraft.banner.guster.yellow": "Giele Wandstoussert",
  "block.minecraft.banner.half_horizontal.black": "Uewe schwaarz gedeelt",
  "block.minecraft.banner.half_horizontal.blue": "Uewe blo gedeelt",
  "block.minecraft.banner.half_horizontal.brown": "Uewe brong gedeelt",
  "block.minecraft.banner.half_horizontal.cyan": "Uewen turquoise gedeelt",
  "block.minecraft.banner.half_horizontal.gray": "Uewe gro gedeelt",
  "block.minecraft.banner.half_horizontal.green": "Uewe gréng gedeelt",
  "block.minecraft.banner.half_horizontal.light_blue": "Uewen hellblo gedeelt",
  "block.minecraft.banner.half_horizontal.light_gray": "Uewen hellgro gedeelt",
  "block.minecraft.banner.half_horizontal.lime": "Uewen hellgréng gedeelt",
  "block.minecraft.banner.half_horizontal.magenta": "Uewe magenta gedeelt",
  "block.minecraft.banner.half_horizontal.orange": "Uewen orange gedeelt",
  "block.minecraft.banner.half_horizontal.pink": "Uewe rosa gedeelt",
  "block.minecraft.banner.half_horizontal.purple": "Uewe mof gedeelt",
  "block.minecraft.banner.half_horizontal.red": "Uewe rout gedeelt",
  "block.minecraft.banner.half_horizontal.white": "Uewe wäiss gedeelt",
  "block.minecraft.banner.half_horizontal.yellow": "Uewe giel gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Enne schwaarz gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Enne blo gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Enne brong gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ennen turquoise gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Enne gro gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Enne gréng gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ennen hellblo gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ennen hellgro gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Ennen hellgréng gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Enne magenta gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Ennen orange gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Enne rosa gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Enne mof gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Enne rout gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Enne wäiss gedeelt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Enne giel gedeelt",
  "block.minecraft.banner.half_vertical.black": "Riets schwaarz gedeelt",
  "block.minecraft.banner.half_vertical.blue": "Riets blo gespléckt",
  "block.minecraft.banner.half_vertical.brown": "Riets brong gedeelt",
  "block.minecraft.banner.half_vertical.cyan": "Riets turquoise gedeelt",
  "block.minecraft.banner.half_vertical.gray": "Riets gro gedeelt",
  "block.minecraft.banner.half_vertical.green": "Riets gréng gedeelt",
  "block.minecraft.banner.half_vertical.light_blue": "Riets hellblo gedeelt",
  "block.minecraft.banner.half_vertical.light_gray": "Riets hellgro gedeelt",
  "block.minecraft.banner.half_vertical.lime": "Riets hellgréng gedeelt",
  "block.minecraft.banner.half_vertical.magenta": "Riets magenta gedeelt",
  "block.minecraft.banner.half_vertical.orange": "Riets orange gedeelt",
  "block.minecraft.banner.half_vertical.pink": "Riets rosa gedeelt",
  "block.minecraft.banner.half_vertical.purple": "Riets mof gedeelt",
  "block.minecraft.banner.half_vertical.red": "Riets rout gedeelt",
  "block.minecraft.banner.half_vertical.white": "Riets wäiss gedeelt",
  "block.minecraft.banner.half_vertical.yellow": "Riets giel gedeelt",
  "block.minecraft.banner.half_vertical_right.black": "Lénks schwaarz gedeelt",
  "block.minecraft.banner.half_vertical_right.blue": "Lénks blo gedeelt",
  "block.minecraft.banner.half_vertical_right.brown": "Lénks brong gedeelt",
  "block.minecraft.banner.half_vertical_right.cyan": "Lénks turquoise gedeelt",
  "block.minecraft.banner.half_vertical_right.gray": "Lénks gro gedeelt",
  "block.minecraft.banner.half_vertical_right.green": "Lénks gréng gedeelt",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lénks hellblo gedeelt",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lénks hellgro gedeelt",
  "block.minecraft.banner.half_vertical_right.lime": "Lénks hellgréng gedeelt",
  "block.minecraft.banner.half_vertical_right.magenta": "Lénks magenta gedeelt",
  "block.minecraft.banner.half_vertical_right.orange": "Lénks orange gedeelt",
  "block.minecraft.banner.half_vertical_right.pink": "Lénks rosa gedeelt",
  "block.minecraft.banner.half_vertical_right.purple": "Lénks mof gedeelt",
  "block.minecraft.banner.half_vertical_right.red": "Lénks rout gedeelt",
  "block.minecraft.banner.half_vertical_right.white": "Lénks wäiss gedeelt",
  "block.minecraft.banner.half_vertical_right.yellow": "Lénks giel gedeelt",
  "block.minecraft.banner.mojang.black": "Schwaarzt Mojang Logo",
  "block.minecraft.banner.mojang.blue": "Blot Mojang Logo",
  "block.minecraft.banner.mojang.brown": "Brongt Mojang Logo",
  "block.minecraft.banner.mojang.cyan": "Turquoiset Mojang Logo",
  "block.minecraft.banner.mojang.gray": "Grot Mojang Logo",
  "block.minecraft.banner.mojang.green": "Gréngt Mojang Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblot Mojang Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgrot Mojang Logo",
  "block.minecraft.banner.mojang.lime": "Hellgréngt Mojang Logo",
  "block.minecraft.banner.mojang.magenta": "Magentat Mojang Logo",
  "block.minecraft.banner.mojang.orange": "Oranget Mojang Logo",
  "block.minecraft.banner.mojang.pink": "Rosat Mojang Logo",
  "block.minecraft.banner.mojang.purple": "Moft Mojang Logo",
  "block.minecraft.banner.mojang.red": "Rout Mojang Logo",
  "block.minecraft.banner.mojang.white": "Wäisst Mojang Logo",
  "block.minecraft.banner.mojang.yellow": "Gielt Mojang Logo",
  "block.minecraft.banner.piglin.black": "Schwaarz Schnëss",
  "block.minecraft.banner.piglin.blue": "Blo Schnëss",
  "block.minecraft.banner.piglin.brown": "Brong Schnëss",
  "block.minecraft.banner.piglin.cyan": "Turquoise Schnëss",
  "block.minecraft.banner.piglin.gray": "Gro Schnëss",
  "block.minecraft.banner.piglin.green": "Gréng Schnëss",
  "block.minecraft.banner.piglin.light_blue": "Hellblo Schnëss",
  "block.minecraft.banner.piglin.light_gray": "Hellgro Schnëss",
  "block.minecraft.banner.piglin.lime": "Hellgréng Schnëss",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnëss",
  "block.minecraft.banner.piglin.orange": "Orange Schnëss",
  "block.minecraft.banner.piglin.pink": "Rosa Schnëss",
  "block.minecraft.banner.piglin.purple": "Mof Schnëss",
  "block.minecraft.banner.piglin.red": "Rout Schnëss",
  "block.minecraft.banner.piglin.white": "Wäiss Schnëss",
  "block.minecraft.banner.piglin.yellow": "Giel Schnëss",
  "block.minecraft.banner.rhombus.black": "Schwaarz Raut",
  "block.minecraft.banner.rhombus.blue": "Blo Raut",
  "block.minecraft.banner.rhombus.brown": "Brong Raut",
  "block.minecraft.banner.rhombus.cyan": "Turquoise Raut",
  "block.minecraft.banner.rhombus.gray": "Gro Raut",
  "block.minecraft.banner.rhombus.green": "Gréng Raut",
  "block.minecraft.banner.rhombus.light_blue": "Hellblo Raut",
  "block.minecraft.banner.rhombus.light_gray": "Hellgro Raut",
  "block.minecraft.banner.rhombus.lime": "Hellgréng Raut",
  "block.minecraft.banner.rhombus.magenta": "Magenta Raut",
  "block.minecraft.banner.rhombus.orange": "Orange Raut",
  "block.minecraft.banner.rhombus.pink": "Rosa Raut",
  "block.minecraft.banner.rhombus.purple": "Mof Raut",
  "block.minecraft.banner.rhombus.red": "Rout Raut",
  "block.minecraft.banner.rhombus.white": "Wäiss Raut",
  "block.minecraft.banner.rhombus.yellow": "Giel Raut",
  "block.minecraft.banner.skull.black": "Schwaarzen Doudekapp",
  "block.minecraft.banner.skull.blue": "Bloen Doudekapp",
  "block.minecraft.banner.skull.brown": "Brongen Doudekapp",
  "block.minecraft.banner.skull.cyan": "Turquoisen Doudekapp",
  "block.minecraft.banner.skull.gray": "Groen Doudekapp",
  "block.minecraft.banner.skull.green": "Gréngen Doudekapp",
  "block.minecraft.banner.skull.light_blue": "Hellbloen Doudekapp",
  "block.minecraft.banner.skull.light_gray": "Hellgroen Doudekapp",
  "block.minecraft.banner.skull.lime": "Hellgréngen Doudekapp",
  "block.minecraft.banner.skull.magenta": "Magentaen Doudekapp",
  "block.minecraft.banner.skull.orange": "Orangen Doudekapp",
  "block.minecraft.banner.skull.pink": "Rosaen Doudekapp",
  "block.minecraft.banner.skull.purple": "Mofen Doudekapp",
  "block.minecraft.banner.skull.red": "Rouden Doudekapp",
  "block.minecraft.banner.skull.white": "Wäissen Doudekapp",
  "block.minecraft.banner.skull.yellow": "Gielen Doudekapp",
  "block.minecraft.banner.small_stripes.black": "Véier schwaarz Péil",
  "block.minecraft.banner.small_stripes.blue": "Véier blo Péil",
  "block.minecraft.banner.small_stripes.brown": "Véier brong Péil",
  "block.minecraft.banner.small_stripes.cyan": "Véier turquoise Péil",
  "block.minecraft.banner.small_stripes.gray": "Véier gro Péil",
  "block.minecraft.banner.small_stripes.green": "Véier gréng Péil",
  "block.minecraft.banner.small_stripes.light_blue": "Véier hellblo Péil",
  "block.minecraft.banner.small_stripes.light_gray": "Véier hellgro Péil",
  "block.minecraft.banner.small_stripes.lime": "Véier hellgréng Péil",
  "block.minecraft.banner.small_stripes.magenta": "Véier magenta Péil",
  "block.minecraft.banner.small_stripes.orange": "Véier orange Péil",
  "block.minecraft.banner.small_stripes.pink": "Véier rosa Péil",
  "block.minecraft.banner.small_stripes.purple": "Véier mof Péil",
  "block.minecraft.banner.small_stripes.red": "Véier rout Péil",
  "block.minecraft.banner.small_stripes.white": "Véier wäiss Péil",
  "block.minecraft.banner.small_stripes.yellow": "Véier giel Péil",
  "block.minecraft.banner.square_bottom_left.black": "Schwaarzen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.blue": "Bloen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.brown": "Brongen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.cyan": "Turquoisen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.gray": "Groen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.green": "Gréngen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellbloen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgroen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgréngen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.magenta": "Magentaen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.orange": "Orangen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.pink": "Rosaen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.purple": "Mofen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.red": "Rouden Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.white": "Wäissen Eck ënne riets",
  "block.minecraft.banner.square_bottom_left.yellow": "Gielen Eck ënne riets",
  "block.minecraft.banner.square_bottom_right.black": "Schwaarzen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.blue": "Bloen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.brown": "Brongen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.cyan": "Turquoisen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.gray": "Groen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.green": "Gréngen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellbloen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgroen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgréngen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.magenta": "Magentaen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.orange": "Orangen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.pink": "Rosaen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.purple": "Mofen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.red": "Rouden Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.white": "Wäissen Eck ënne lénks",
  "block.minecraft.banner.square_bottom_right.yellow": "Gielen Eck ënne lénks",
  "block.minecraft.banner.square_top_left.black": "Schwaarzen Eck uewe riets",
  "block.minecraft.banner.square_top_left.blue": "Bloen Eck uewe riets",
  "block.minecraft.banner.square_top_left.brown": "Brongen Eck uewe riets",
  "block.minecraft.banner.square_top_left.cyan": "Turquoisen Eck uewe riets",
  "block.minecraft.banner.square_top_left.gray": "Groen Eck uewe riets",
  "block.minecraft.banner.square_top_left.green": "Gréngen Eck uewe riets",
  "block.minecraft.banner.square_top_left.light_blue": "Hellbloen Eck uewe riets",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgroen Eck uewe riets",
  "block.minecraft.banner.square_top_left.lime": "Hellgréngen Eck uewe riets",
  "block.minecraft.banner.square_top_left.magenta": "Magentaen Eck uewe riets",
  "block.minecraft.banner.square_top_left.orange": "Orangen Eck uewe riets",
  "block.minecraft.banner.square_top_left.pink": "Rosaen Eck uewe riets",
  "block.minecraft.banner.square_top_left.purple": "Mofen Eck uewe riets",
  "block.minecraft.banner.square_top_left.red": "Rouden Eck uewe riets",
  "block.minecraft.banner.square_top_left.white": "Wäissen Eck uewe riets",
  "block.minecraft.banner.square_top_left.yellow": "Gielen Eck uewe riets",
  "block.minecraft.banner.square_top_right.black": "Schwaarzen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.blue": "Bloen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.brown": "Brongen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.cyan": "Turquoisen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.gray": "Groen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.green": "Gréngen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.light_blue": "Hellbloen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgroen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.lime": "Hellgréngen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.magenta": "Magentaen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.orange": "Orangen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.pink": "Rosaen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.purple": "Mofen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.red": "Rouden Eck uewe lénks",
  "block.minecraft.banner.square_top_right.white": "Wäissen Eck uewe lénks",
  "block.minecraft.banner.square_top_right.yellow": "Gielen Eck uewe lénks",
  "block.minecraft.banner.straight_cross.black": "Schwaarzt Kräiz",
  "block.minecraft.banner.straight_cross.blue": "Blot Kräiz",
  "block.minecraft.banner.straight_cross.brown": "Brongt Kräiz",
  "block.minecraft.banner.straight_cross.cyan": "Turquoiset Kräiz",
  "block.minecraft.banner.straight_cross.gray": "Grot Kräiz",
  "block.minecraft.banner.straight_cross.green": "Gréngt Kräiz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblot Kräiz",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgrot Kräiz",
  "block.minecraft.banner.straight_cross.lime": "Hellgréngt Kräiz",
  "block.minecraft.banner.straight_cross.magenta": "Magentat Kräiz",
  "block.minecraft.banner.straight_cross.orange": "Oranget Kräiz",
  "block.minecraft.banner.straight_cross.pink": "Rosat Kräiz",
  "block.minecraft.banner.straight_cross.purple": "Moft Kräiz",
  "block.minecraft.banner.straight_cross.red": "Rout Kräiz",
  "block.minecraft.banner.straight_cross.white": "Wäisst Kräiz",
  "block.minecraft.banner.straight_cross.yellow": "Gielt Kräiz",
  "block.minecraft.banner.stripe_bottom.black": "Schwaarze Fändelfouss",
  "block.minecraft.banner.stripe_bottom.blue": "Bloe Fändelfouss",
  "block.minecraft.banner.stripe_bottom.brown": "Bronge Fändelfouss",
  "block.minecraft.banner.stripe_bottom.cyan": "Turquoise Fändelfouss",
  "block.minecraft.banner.stripe_bottom.gray": "Groe Fändelfouss",
  "block.minecraft.banner.stripe_bottom.green": "Grénge Fändelfouss",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellbloe Fändelfouss",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellgroe Fändelfouss",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrénge Fändelfouss",
  "block.minecraft.banner.stripe_bottom.magenta": "Magentae Fändelfouss",
  "block.minecraft.banner.stripe_bottom.orange": "Orangë Fändelfouss",
  "block.minecraft.banner.stripe_bottom.pink": "Rosae Fändelfouss",
  "block.minecraft.banner.stripe_bottom.purple": "Mofe Fändelfouss",
  "block.minecraft.banner.stripe_bottom.red": "Roude Fändelfouss",
  "block.minecraft.banner.stripe_bottom.white": "Wäisse Fändelfouss",
  "block.minecraft.banner.stripe_bottom.yellow": "Giele Fändelfouss",
  "block.minecraft.banner.stripe_center.black": "Schwaarze Poul",
  "block.minecraft.banner.stripe_center.blue": "Bloe Poul",
  "block.minecraft.banner.stripe_center.brown": "Bronge Poul",
  "block.minecraft.banner.stripe_center.cyan": "Turquoise Poul",
  "block.minecraft.banner.stripe_center.gray": "Groe Poul",
  "block.minecraft.banner.stripe_center.green": "Grénge Poul",
  "block.minecraft.banner.stripe_center.light_blue": "Hellbloe Poul",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgroe Poul",
  "block.minecraft.banner.stripe_center.lime": "Hellgrénge Poul",
  "block.minecraft.banner.stripe_center.magenta": "Magentae Poul",
  "block.minecraft.banner.stripe_center.orange": "Orange Poul",
  "block.minecraft.banner.stripe_center.pink": "Rosae Poul",
  "block.minecraft.banner.stripe_center.purple": "Mofe Poul",
  "block.minecraft.banner.stripe_center.red": "Roude Poul",
  "block.minecraft.banner.stripe_center.white": "Wäisse Poul",
  "block.minecraft.banner.stripe_center.yellow": "Giele Poul",
  "block.minecraft.banner.stripe_downleft.black": "Schwaarz Schréi lénks",
  "block.minecraft.banner.stripe_downleft.blue": "Blo Schréi lénks",
  "block.minecraft.banner.stripe_downleft.brown": "Brong Schréi lénks",
  "block.minecraft.banner.stripe_downleft.cyan": "Turquoise Schréi lénks",
  "block.minecraft.banner.stripe_downleft.gray": "Gro Schréi lénks",
  "block.minecraft.banner.stripe_downleft.green": "Gréng Schréi lénks",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblo Schréi lénks",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgro Schréi lénks",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgréng Schréi lénks",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Schréi lénks",
  "block.minecraft.banner.stripe_downleft.orange": "Orange Schréi lénks",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa Schréi lénks",
  "block.minecraft.banner.stripe_downleft.purple": "Mof Schréi lénks",
  "block.minecraft.banner.stripe_downleft.red": "Rout Schréi lénks",
  "block.minecraft.banner.stripe_downleft.white": "Wäiss Schréi lénks",
  "block.minecraft.banner.stripe_downleft.yellow": "Giel Schréi lénks",
  "block.minecraft.banner.stripe_downright.black": "Schwaarz Schréi",
  "block.minecraft.banner.stripe_downright.blue": "Blo Schréi",
  "block.minecraft.banner.stripe_downright.brown": "Brong Schréi",
  "block.minecraft.banner.stripe_downright.cyan": "Turquoise Schréi",
  "block.minecraft.banner.stripe_downright.gray": "Gro Schréi",
  "block.minecraft.banner.stripe_downright.green": "Gréng Schréi",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblo Schréi",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgro Schréi",
  "block.minecraft.banner.stripe_downright.lime": "Hellgréng Schréi",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Schréi",
  "block.minecraft.banner.stripe_downright.orange": "Orange Schréi",
  "block.minecraft.banner.stripe_downright.pink": "Rosa Schréi",
  "block.minecraft.banner.stripe_downright.purple": "Mof Schréi",
  "block.minecraft.banner.stripe_downright.red": "Rout Schréi",
  "block.minecraft.banner.stripe_downright.white": "Wäiss Schréi",
  "block.minecraft.banner.stripe_downright.yellow": "Giel Schréi",
  "block.minecraft.banner.stripe_left.black": "Schwaarz Flank riets",
  "block.minecraft.banner.stripe_left.blue": "Blo Flank riets",
  "block.minecraft.banner.stripe_left.brown": "Brong Flank riets",
  "block.minecraft.banner.stripe_left.cyan": "Turquoise Flank riets",
  "block.minecraft.banner.stripe_left.gray": "Gro Flank riets",
  "block.minecraft.banner.stripe_left.green": "Gréng Flank riets",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblo Flank riets",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgro Flank riets",
  "block.minecraft.banner.stripe_left.lime": "Hellgréng Flank riets",
  "block.minecraft.banner.stripe_left.magenta": "Magenta Flank riets",
  "block.minecraft.banner.stripe_left.orange": "Orange Flank riets",
  "block.minecraft.banner.stripe_left.pink": "Rosa Flank riets",
  "block.minecraft.banner.stripe_left.purple": "Mof Flank riets",
  "block.minecraft.banner.stripe_left.red": "Rout Flank riets",
  "block.minecraft.banner.stripe_left.white": "Wäiss Flank riets",
  "block.minecraft.banner.stripe_left.yellow": "Giel Flank riets",
  "block.minecraft.banner.stripe_middle.black": "Schwaarze Balken",
  "block.minecraft.banner.stripe_middle.blue": "Bloe Balken",
  "block.minecraft.banner.stripe_middle.brown": "Bronge Balken",
  "block.minecraft.banner.stripe_middle.cyan": "Turquoise Balken",
  "block.minecraft.banner.stripe_middle.gray": "Groe Balken",
  "block.minecraft.banner.stripe_middle.green": "Grénge Balken",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellbloe Balken",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgroe Balken",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrénge Balken",
  "block.minecraft.banner.stripe_middle.magenta": "Magentae Balken",
  "block.minecraft.banner.stripe_middle.orange": "Orange Balken",
  "block.minecraft.banner.stripe_middle.pink": "Rosae Balken",
  "block.minecraft.banner.stripe_middle.purple": "Mofe Balken",
  "block.minecraft.banner.stripe_middle.red": "Roude Balken",
  "block.minecraft.banner.stripe_middle.white": "Wäisse Balken",
  "block.minecraft.banner.stripe_middle.yellow": "Giele Balken",
  "block.minecraft.banner.stripe_right.black": "Schwaarz Flank lénks",
  "block.minecraft.banner.stripe_right.blue": "Blo Flank lénks",
  "block.minecraft.banner.stripe_right.brown": "Brong Flank lénks",
  "block.minecraft.banner.stripe_right.cyan": "Turquoise Flank lénks",
  "block.minecraft.banner.stripe_right.gray": "Gro Flank lénks",
  "block.minecraft.banner.stripe_right.green": "Gréng Flank lénks",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblo Flank lénks",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgro Flank lénks",
  "block.minecraft.banner.stripe_right.lime": "Hellgréng Flank lénks",
  "block.minecraft.banner.stripe_right.magenta": "Magenta Flank lénks",
  "block.minecraft.banner.stripe_right.orange": "Orange Flank lénks",
  "block.minecraft.banner.stripe_right.pink": "Rosa Flank lénks",
  "block.minecraft.banner.stripe_right.purple": "Mof Flank lénks",
  "block.minecraft.banner.stripe_right.red": "Rout Flank lénks",
  "block.minecraft.banner.stripe_right.white": "Wäiss Flank lénks",
  "block.minecraft.banner.stripe_right.yellow": "Giel Flank lénks",
  "block.minecraft.banner.stripe_top.black": "Schwaarze Fändelkapp",
  "block.minecraft.banner.stripe_top.blue": "Bloe Fändelkapp",
  "block.minecraft.banner.stripe_top.brown": "Bronge Fändelkapp",
  "block.minecraft.banner.stripe_top.cyan": "Turquoise Fändelkapp",
  "block.minecraft.banner.stripe_top.gray": "Groe Fändelkapp",
  "block.minecraft.banner.stripe_top.green": "Grénge Fändelkapp",
  "block.minecraft.banner.stripe_top.light_blue": "Hellbloe Fändelkapp",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgroe Fändelkapp",
  "block.minecraft.banner.stripe_top.lime": "Hellgrénge Fändelkapp",
  "block.minecraft.banner.stripe_top.magenta": "Magentae Fändelkapp",
  "block.minecraft.banner.stripe_top.orange": "Orangë Fändelkapp",
  "block.minecraft.banner.stripe_top.pink": "Rosae Fändelkapp",
  "block.minecraft.banner.stripe_top.purple": "Mofe Fändelkapp",
  "block.minecraft.banner.stripe_top.red": "Roude Fändelkapp",
  "block.minecraft.banner.stripe_top.white": "Wäisse Fändelkapp",
  "block.minecraft.banner.stripe_top.yellow": "Giele Fändelkapp",
  "block.minecraft.banner.triangle_bottom.black": "Schwaarz Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.blue": "Blo Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.brown": "Brong Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.cyan": "Turquoise Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.gray": "Gro Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.green": "Gréng Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblo Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgro Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgréng Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.orange": "Orange Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.purple": "Mof Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.red": "Rout Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.white": "Wäiss Hallefspëtz",
  "block.minecraft.banner.triangle_bottom.yellow": "Giel Hallefspëtz",
  "block.minecraft.banner.triangle_top.black": "Schwaarz gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.blue": "Blo gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.brown": "Brong gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.cyan": "Turquoise gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.gray": "Gro gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.green": "Gréng gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblo gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgro gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.lime": "Hellgréng gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.magenta": "Magenta gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.orange": "Orange gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.pink": "Rosa gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.purple": "Mof gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.red": "Rout gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.white": "Wäiss gedréinten Hallefspëtz",
  "block.minecraft.banner.triangle_top.yellow": "Giel gedréinten Hallefspëtz",
  "block.minecraft.banner.triangles_bottom.black": "Schwaarz Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.blue": "Blo Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.brown": "Brong Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.cyan": "Turquoise Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.gray": "Gro Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.green": "Gréng Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblo Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgro Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgréng Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.orange": "Orange Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.purple": "Mof Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.red": "Rout Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.white": "Wäiss Zacken ënnen",
  "block.minecraft.banner.triangles_bottom.yellow": "Giel Zacken ënnen",
  "block.minecraft.banner.triangles_top.black": "Schwaarz Zacken uewen",
  "block.minecraft.banner.triangles_top.blue": "Blo Zacken uewen",
  "block.minecraft.banner.triangles_top.brown": "Brong Zacken uewen",
  "block.minecraft.banner.triangles_top.cyan": "Turquoise Zacken uewen",
  "block.minecraft.banner.triangles_top.gray": "Gro Zacken uewen",
  "block.minecraft.banner.triangles_top.green": "Gréng Zacken uewen",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblo Zacken uewen",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgro Zacken uewen",
  "block.minecraft.banner.triangles_top.lime": "Hellgréng Zacken uewen",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Zacken uewen",
  "block.minecraft.banner.triangles_top.orange": "Orange Zacken uewen",
  "block.minecraft.banner.triangles_top.pink": "Rosa Zacken uewen",
  "block.minecraft.banner.triangles_top.purple": "Mof Zacken uewen",
  "block.minecraft.banner.triangles_top.red": "Rout Zacken uewen",
  "block.minecraft.banner.triangles_top.white": "Wäiss Zacken uewen",
  "block.minecraft.banner.triangles_top.yellow": "Giel Zacken uewen",
  "block.minecraft.barrel": "Faass",
  "block.minecraft.barrier": "Barrière",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Liichtfeier",
  "block.minecraft.beacon.primary": "Primärkraaft",
  "block.minecraft.beacon.secondary": "Sekundärkraaft",
  "block.minecraft.bed.no_sleep": "Du kanns nëmmen an der Nuecht oder wärend engem Donnerwieder schlofen",
  "block.minecraft.bed.not_safe": "Du kanns elo net schlofen, et si Monster an déi Ëmgéigend",
  "block.minecraft.bed.obstructed": "Dëst Bett ass blockéiert",
  "block.minecraft.bed.occupied": "D'Bett ass besat",
  "block.minecraft.bed.too_far_away": "Du kanns elo net schlofen, d'Bett ass ze weit fort",
  "block.minecraft.bedrock": "Grondsteen",
  "block.minecraft.bee_nest": "Beiennascht",
  "block.minecraft.beehive": "Beiestack",
  "block.minecraft.beetroots": "Rout Rommelen",
  "block.minecraft.bell": "Klack",
  "block.minecraft.big_dripleaf": "Grousst Drëpsblat",
  "block.minecraft.big_dripleaf_stem": "Grousse Drëpsblatstiel",
  "block.minecraft.birch_button": "Bierkenholzknäppchen",
  "block.minecraft.birch_door": "Bierkenholzdier",
  "block.minecraft.birch_fence": "Bierkenholzzonk",
  "block.minecraft.birch_fence_gate": "Bierkenholzzonkpaart",
  "block.minecraft.birch_hanging_sign": "Bierkenholzhängeschëld",
  "block.minecraft.birch_leaves": "Bierkeblieder",
  "block.minecraft.birch_log": "Bierkestamm",
  "block.minecraft.birch_planks": "Bierkenholzbrieder",
  "block.minecraft.birch_pressure_plate": "Bierkenholzdrockplack",
  "block.minecraft.birch_sapling": "Bierkesetzlek",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Bierkenholzschëld",
  "block.minecraft.birch_slab": "Bierkenholzplack",
  "block.minecraft.birch_stairs": "Bierkenholztrap",
  "block.minecraft.birch_trapdoor": "Bierkenholzklappdier",
  "block.minecraft.birch_wall_hanging_sign": "Bierkenholzmauerhängeschëld",
  "block.minecraft.birch_wall_sign": "Bierkenholzmauerschëld",
  "block.minecraft.birch_wood": "Bierkenholz",
  "block.minecraft.black_banner": "Schwaarze Fändel",
  "block.minecraft.black_bed": "Schwaarzt Bett",
  "block.minecraft.black_candle": "Schwaarz Käerz",
  "block.minecraft.black_candle_cake": "Kuch mat schwaarzer Käerz",
  "block.minecraft.black_carpet": "Schwaarzen Teppech",
  "block.minecraft.black_concrete": "Schwaarze Bëtong",
  "block.minecraft.black_concrete_powder": "Schwaarzen Zement",
  "block.minecraft.black_glazed_terracotta": "Glaséiert schwaarz Keramik",
  "block.minecraft.black_shulker_box": "Schwaarz Shulker-Këscht",
  "block.minecraft.black_stained_glass": "Schwaarzt Glas",
  "block.minecraft.black_stained_glass_pane": "Schwaarz Glasscheif",
  "block.minecraft.black_terracotta": "Schwaarz Keramik",
  "block.minecraft.black_wool": "Schwaarz Woll",
  "block.minecraft.blackstone": "Schwaarzsteen",
  "block.minecraft.blackstone_slab": "Schwaarzsteeplack",
  "block.minecraft.blackstone_stairs": "Schwaarzsteentrap",
  "block.minecraft.blackstone_wall": "Schwaarzsteemauer",
  "block.minecraft.blast_furnace": "Schmelzuewen",
  "block.minecraft.blue_banner": "Bloe Fändel",
  "block.minecraft.blue_bed": "Blot Bett",
  "block.minecraft.blue_candle": "Blo Käerz",
  "block.minecraft.blue_candle_cake": "Kuch mat bloer Käerz",
  "block.minecraft.blue_carpet": "Bloen Teppech",
  "block.minecraft.blue_concrete": "Bloe Bëtong",
  "block.minecraft.blue_concrete_powder": "Bloen Zement",
  "block.minecraft.blue_glazed_terracotta": "Glaséiert blo Keramik",
  "block.minecraft.blue_ice": "Bloäis",
  "block.minecraft.blue_orchid": "Blo Orchidee",
  "block.minecraft.blue_shulker_box": "Blo Shulker-Këscht",
  "block.minecraft.blue_stained_glass": "Blot Glas",
  "block.minecraft.blue_stained_glass_pane": "Blo Glasscheif",
  "block.minecraft.blue_terracotta": "Blo Keramik",
  "block.minecraft.blue_wool": "Blo Woll",
  "block.minecraft.bone_block": "Schankeblock",
  "block.minecraft.bookshelf": "Bicherregal",
  "block.minecraft.brain_coral": "Hirkorall",
  "block.minecraft.brain_coral_block": "Hirkoralleblock",
  "block.minecraft.brain_coral_fan": "Hirkorallefächer",
  "block.minecraft.brain_coral_wall_fan": "Hirkorallemauerfächer",
  "block.minecraft.brewing_stand": "Braustand",
  "block.minecraft.brick_slab": "Zilleplack",
  "block.minecraft.brick_stairs": "Zillentrap",
  "block.minecraft.brick_wall": "Zillemauer",
  "block.minecraft.bricks": "Zillen",
  "block.minecraft.brown_banner": "Bronge Fändel",
  "block.minecraft.brown_bed": "Brongt Bett",
  "block.minecraft.brown_candle": "Brong Käerz",
  "block.minecraft.brown_candle_cake": "Kuch mat bronger Käerz",
  "block.minecraft.brown_carpet": "Brongen Teppech",
  "block.minecraft.brown_concrete": "Bronge Bëtong",
  "block.minecraft.brown_concrete_powder": "Brongen Zement",
  "block.minecraft.brown_glazed_terracotta": "Glaséiert brong Keramik",
  "block.minecraft.brown_mushroom": "Bronge Champignon",
  "block.minecraft.brown_mushroom_block": "Bronge Champignonblock",
  "block.minecraft.brown_shulker_box": "Brong Shulker-Këscht",
  "block.minecraft.brown_stained_glass": "Brongt Glas",
  "block.minecraft.brown_stained_glass_pane": "Brong Glasscheif",
  "block.minecraft.brown_terracotta": "Brong Keramik",
  "block.minecraft.brown_wool": "Brong Woll",
  "block.minecraft.bubble_column": "Blosesail",
  "block.minecraft.bubble_coral": "Blosekorall",
  "block.minecraft.bubble_coral_block": "Blosekoralleblock",
  "block.minecraft.bubble_coral_fan": "Blosekorallefächer",
  "block.minecraft.bubble_coral_wall_fan": "Blosekorallemauerfächer",
  "block.minecraft.budding_amethyst": "Amethystknospeblock",
  "block.minecraft.bush": "Busch",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusbléi",
  "block.minecraft.cake": "Kuch",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibréierte Sculk-Sensor",
  "block.minecraft.campfire": "Lagerfeier",
  "block.minecraft.candle": "Käerz",
  "block.minecraft.candle_cake": "Kuch mat Käerz",
  "block.minecraft.carrots": "Muerten",
  "block.minecraft.cartography_table": "Kaartendësch",
  "block.minecraft.carved_pumpkin": "Geschnëtzte Kürbis",
  "block.minecraft.cauldron": "Kessel",
  "block.minecraft.cave_air": "Höleloft",
  "block.minecraft.cave_vines": "Höleranken",
  "block.minecraft.cave_vines_plant": "Höhlerankeplanz",
  "block.minecraft.chain": "Ketten",
  "block.minecraft.chain_command_block": "Kette Befeelsblock",
  "block.minecraft.cherry_button": "Kiischtenholzknäppchen",
  "block.minecraft.cherry_door": "Kiischtenholzdier",
  "block.minecraft.cherry_fence": "Kiischtenholzzonk",
  "block.minecraft.cherry_fence_gate": "Kiischtenholzzonkpaart",
  "block.minecraft.cherry_hanging_sign": "Kiischtenholzhängeschëld",
  "block.minecraft.cherry_leaves": "Kiischteblieder",
  "block.minecraft.cherry_log": "Kiischtenholzstamm",
  "block.minecraft.cherry_planks": "Kiischtenholzbrieder",
  "block.minecraft.cherry_pressure_plate": "Kiischtenholzdrockplack",
  "block.minecraft.cherry_sapling": "Kiischtesetzlek",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Kiischtenholzschëld",
  "block.minecraft.cherry_slab": "Kiischtenholzplack",
  "block.minecraft.cherry_stairs": "Kiischtenholztrap",
  "block.minecraft.cherry_trapdoor": "Kiischtenholzklappdier",
  "block.minecraft.cherry_wall_hanging_sign": "Kiischtenholzmauerhängeschëld",
  "block.minecraft.cherry_wall_sign": "Kischtenholzmauerschëld",
  "block.minecraft.cherry_wood": "Kiischtenholz",
  "block.minecraft.chest": "Këscht",
  "block.minecraft.chipped_anvil": "Ugeschloenen Amboss",
  "block.minecraft.chiseled_bookshelf": "Huelt Bicherregal",
  "block.minecraft.chiseled_copper": "Gemeesselte Kofferblock",
  "block.minecraft.chiseled_deepslate": "Gemeesselte Déiweschifer",
  "block.minecraft.chiseled_nether_bricks": "Gemeesselt Netherzillen",
  "block.minecraft.chiseled_polished_blackstone": "Gemeesselte poléierte Schwarzsteen",
  "block.minecraft.chiseled_quartz_block": "Gemeesselte Quarzblock",
  "block.minecraft.chiseled_red_sandstone": "Gemeesselte roude Sandsteen",
  "block.minecraft.chiseled_resin_bricks": "Gemeesselt Harzzillen",
  "block.minecraft.chiseled_sandstone": "Gemeesselte Sandsteen",
  "block.minecraft.chiseled_stone_bricks": "Gemeesselt Steenzillen",
  "block.minecraft.chiseled_tuff": "Gemeesselt Trass",
  "block.minecraft.chiseled_tuff_bricks": "Gemeesselt Trasszillen",
  "block.minecraft.chorus_flower": "Chorusbléi",
  "block.minecraft.chorus_plant": "Chorusplanz",
  "block.minecraft.clay": "Toun",
  "block.minecraft.closed_eyeblossom": "Zouen Ablumm",
  "block.minecraft.coal_block": "Kueleblock",
  "block.minecraft.coal_ore": "Steekuel",
  "block.minecraft.coarse_dirt": "Graff Äerd",
  "block.minecraft.cobbled_deepslate": "Brochdéiweschifer",
  "block.minecraft.cobbled_deepslate_slab": "Brochdéiweschiferplack",
  "block.minecraft.cobbled_deepslate_stairs": "Brochdéiweschifertrap",
  "block.minecraft.cobbled_deepslate_wall": "Brochdéiweschifermauer",
  "block.minecraft.cobblestone": "Brochsteen",
  "block.minecraft.cobblestone_slab": "Brochsteeplack",
  "block.minecraft.cobblestone_stairs": "Brochsteentrap",
  "block.minecraft.cobblestone_wall": "Brochsteemauer",
  "block.minecraft.cobweb": "Spaweck",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Befeelsblock",
  "block.minecraft.comparator": "Redstone-Komparator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Conduit",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Kofferblock",
  "block.minecraft.copper_bulb": "Kofferbier",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Kofferdier",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Koffergitter",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Kofferäerz",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Kofferklappdier",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Karblumm",
  "block.minecraft.cracked_deepslate_bricks": "Briques d'ardoise profonde fissurées",
  "block.minecraft.cracked_deepslate_tiles": "Rësseg Déiweschiferplättercher",
  "block.minecraft.cracked_nether_bricks": "Rësseg Netherzillen",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rësseg poléiert Schwarzsteenzillen",
  "block.minecraft.cracked_stone_bricks": "Rësseg Steenzillen",
  "block.minecraft.crafter": "Wierker",
  "block.minecraft.crafting_table": "Wierkbänk",
  "block.minecraft.creaking_heart": "Knarzend Häerz",
  "block.minecraft.creeper_head": "Creeperkapp",
  "block.minecraft.creeper_wall_head": "Creepermauerkapp",
  "block.minecraft.crimson_button": "Karmesinknäppchen",
  "block.minecraft.crimson_door": "Karmesindier",
  "block.minecraft.crimson_fence": "Karmesinzonk",
  "block.minecraft.crimson_fence_gate": "Karmesinzonkpaart",
  "block.minecraft.crimson_fungus": "Karmesin Champignon",
  "block.minecraft.crimson_hanging_sign": "Karmesinhängeschëld",
  "block.minecraft.crimson_hyphae": "Karmesinhyphen",
  "block.minecraft.crimson_nylium": "Karmesin-Nylium",
  "block.minecraft.crimson_planks": "Karmesinbrieder",
  "block.minecraft.crimson_pressure_plate": "Karmesindrockplack",
  "block.minecraft.crimson_roots": "Karmesinwuerzelen",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Karmesinschëld",
  "block.minecraft.crimson_slab": "Karmesinplack",
  "block.minecraft.crimson_stairs": "Karmesintrap",
  "block.minecraft.crimson_stem": "Karmesinstill",
  "block.minecraft.crimson_trapdoor": "Karmesinklappdier",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinmauerhängeschëld",
  "block.minecraft.crimson_wall_sign": "Karmesinmauerschëld",
  "block.minecraft.crying_obsidian": "Kräischenden Obsidian",
  "block.minecraft.cut_copper": "Geschniddene Kofferblock",
  "block.minecraft.cut_copper_slab": "Geschnidde Kofferplack",
  "block.minecraft.cut_copper_stairs": "Geschnidde Koffertrap",
  "block.minecraft.cut_red_sandstone": "Geschniddene roude Sandsteen",
  "block.minecraft.cut_red_sandstone_slab": "Geschnidde rout Sandsteeplack",
  "block.minecraft.cut_sandstone": "Geschniddene Sandsteen",
  "block.minecraft.cut_sandstone_slab": "Geschnidde Sandsteeplack",
  "block.minecraft.cyan_banner": "Turquoise Fändel",
  "block.minecraft.cyan_bed": "Turquoiset Bett",
  "block.minecraft.cyan_candle": "Turquoise Käerz",
  "block.minecraft.cyan_candle_cake": "Kuch mat turquoiser Käerz",
  "block.minecraft.cyan_carpet": "Turquoisen Teppech",
  "block.minecraft.cyan_concrete": "Turquoise Bëtong",
  "block.minecraft.cyan_concrete_powder": "Turquoisen Zement",
  "block.minecraft.cyan_glazed_terracotta": "Glaséiert turquoise Keramik",
  "block.minecraft.cyan_shulker_box": "Turquoise Shulker-Këscht",
  "block.minecraft.cyan_stained_glass": "Turquoiset Glas",
  "block.minecraft.cyan_stained_glass_pane": "Turquoise Glasscheif",
  "block.minecraft.cyan_terracotta": "Turquoise Keramik",
  "block.minecraft.cyan_wool": "Turquoise Woll",
  "block.minecraft.damaged_anvil": "Beschiedegten Amboss",
  "block.minecraft.dandelion": "Bettseechesch",
  "block.minecraft.dark_oak_button": "Schwaarzeechenholzknäppchen",
  "block.minecraft.dark_oak_door": "Schwaarzeechenholzdier",
  "block.minecraft.dark_oak_fence": "Schwaarzeechenholzzonk",
  "block.minecraft.dark_oak_fence_gate": "Schwaarzeechenholzzonkpaart",
  "block.minecraft.dark_oak_hanging_sign": "Schwaarzeechehängeschëld",
  "block.minecraft.dark_oak_leaves": "Schwaarzeecheblieder",
  "block.minecraft.dark_oak_log": "Schwaarzeechestamm",
  "block.minecraft.dark_oak_planks": "Schwaarzeechenholzbrieder",
  "block.minecraft.dark_oak_pressure_plate": "Schwaarzeechenholzdrockplack",
  "block.minecraft.dark_oak_sapling": "Schwaarzeechesetzlek",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Schwaarzeechenholzschëld",
  "block.minecraft.dark_oak_slab": "Schwaarzeechenholzplack",
  "block.minecraft.dark_oak_stairs": "Schwaarzeechenholztrap",
  "block.minecraft.dark_oak_trapdoor": "Schwaarzeechenholzklappdier",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwaarzeechewandhängeschëld",
  "block.minecraft.dark_oak_wall_sign": "Schwaarzeechenholzmauerschëld",
  "block.minecraft.dark_oak_wood": "Schwaarzeechenholz",
  "block.minecraft.dark_prismarine": "Donkele Prismarin",
  "block.minecraft.dark_prismarine_slab": "Donkel Prismarinplack",
  "block.minecraft.dark_prismarine_stairs": "Donkel Prismarintrap",
  "block.minecraft.daylight_detector": "Liichtsensor",
  "block.minecraft.dead_brain_coral": "Ofgestuerwe Hirkorall",
  "block.minecraft.dead_brain_coral_block": "Ofgestuerwene Hirkoralleblock",
  "block.minecraft.dead_brain_coral_fan": "Ofgestuerwene Hirkorallefächer",
  "block.minecraft.dead_brain_coral_wall_fan": "Ofgestuerwene Hirkorallemauerfächer",
  "block.minecraft.dead_bubble_coral": "Ofgestuerwe Blosekorall",
  "block.minecraft.dead_bubble_coral_block": "Ofgestuerwene Blosekoralleblock",
  "block.minecraft.dead_bubble_coral_fan": "Ofgestuerwene Blosekorallefächer",
  "block.minecraft.dead_bubble_coral_wall_fan": "Ofgestuerwene Blosekorallemauerfächer",
  "block.minecraft.dead_bush": "Ofgestuerwene Strauch",
  "block.minecraft.dead_fire_coral": "Ofgestuerwe Féierkorall",
  "block.minecraft.dead_fire_coral_block": "Ofgestuerwene Féierkoralleblock",
  "block.minecraft.dead_fire_coral_fan": "Ofgestuerwene Féierkorallefächer",
  "block.minecraft.dead_fire_coral_wall_fan": "Ofgestuerwene Féierkorallemauerfächer",
  "block.minecraft.dead_horn_coral": "Ofgestuerwe Geweikorall",
  "block.minecraft.dead_horn_coral_block": "Ofgestuerwene Geweikoralleblock",
  "block.minecraft.dead_horn_coral_fan": "Ofgestuerwene Geweikorallefächer",
  "block.minecraft.dead_horn_coral_wall_fan": "Ofgestuerwene Geweikorallemauerfächer",
  "block.minecraft.dead_tube_coral": "Ofgestuerwe Uergelkorall",
  "block.minecraft.dead_tube_coral_block": "Ofgestuerwene Uergelkoralleblock",
  "block.minecraft.dead_tube_coral_fan": "Ofgestuerwene Uergelkorallefächer",
  "block.minecraft.dead_tube_coral_wall_fan": "Ofgestuerwene Uergelkorallemauerfächer",
  "block.minecraft.decorated_pot": "Dekoréierten Krou",
  "block.minecraft.deepslate": "Déiweschifer",
  "block.minecraft.deepslate_brick_slab": "Déiweschiferzilleplack",
  "block.minecraft.deepslate_brick_stairs": "Déiweschiferzilletrap",
  "block.minecraft.deepslate_brick_wall": "Déiweschiferzillewand",
  "block.minecraft.deepslate_bricks": "Déiweschiferzillen",
  "block.minecraft.deepslate_coal_ore": "Déiweschifer-Steekuel",
  "block.minecraft.deepslate_copper_ore": "Déiweschifer-Kofferäerz",
  "block.minecraft.deepslate_diamond_ore": "Déiweschifer-Diamantäerz",
  "block.minecraft.deepslate_emerald_ore": "Déiweschifer-Smaragdäerz",
  "block.minecraft.deepslate_gold_ore": "Déiweschifer-Goldäerz",
  "block.minecraft.deepslate_iron_ore": "Déiweschifer-Eisenäerz",
  "block.minecraft.deepslate_lapis_ore": "Déiweschifer-Lapislazuliäerz",
  "block.minecraft.deepslate_redstone_ore": "Déiweschifer-Redstone-Äerz",
  "block.minecraft.deepslate_tile_slab": "Déiweschiferplättercherplack",
  "block.minecraft.deepslate_tile_stairs": "Déiweschiferplättercheretrap",
  "block.minecraft.deepslate_tile_wall": "Déiweschiferplättercherwand",
  "block.minecraft.deepslate_tiles": "Déiweschiferplättercher",
  "block.minecraft.detector_rail": "Sensorschinn",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamantäerz",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritplack",
  "block.minecraft.diorite_stairs": "Diorittrap",
  "block.minecraft.diorite_wall": "Dioritmauer",
  "block.minecraft.dirt": "Äerd",
  "block.minecraft.dirt_path": "Feldwee",
  "block.minecraft.dispenser": "Verdeeler",
  "block.minecraft.dragon_egg": "Draachenee",
  "block.minecraft.dragon_head": "Draachenkapp",
  "block.minecraft.dragon_wall_head": "Draachenmauerkapp",
  "block.minecraft.dried_ghast": "Verdréchente Ghast",
  "block.minecraft.dried_kelp_block": "Gedréchenten Algeblock",
  "block.minecraft.dripstone_block": "Drëpssteeblock",
  "block.minecraft.dropper": "Spender",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragdäerz",
  "block.minecraft.enchanting_table": "Zauberdësch",
  "block.minecraft.end_gateway": "Endtransitportal",
  "block.minecraft.end_portal": "Endportal",
  "block.minecraft.end_portal_frame": "Endportalkader",
  "block.minecraft.end_rod": "Endstaf",
  "block.minecraft.end_stone": "Endsteen",
  "block.minecraft.end_stone_brick_slab": "Endsteenzilleplack",
  "block.minecraft.end_stone_brick_stairs": "Endsteenzillentrap",
  "block.minecraft.end_stone_brick_wall": "Endsteenzillemauer",
  "block.minecraft.end_stone_bricks": "Endsteenzillen",
  "block.minecraft.ender_chest": "Enderkëscht",
  "block.minecraft.exposed_chiseled_copper": "Ausgesate gemeesselte Kofferblock",
  "block.minecraft.exposed_copper": "Ausgesate Kofferblock",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Ausgesat Kofferbier",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Ausgesat Kofferdier",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Ausgesate Koffergitter",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Ausgesat Kofferklappdier",
  "block.minecraft.exposed_cut_copper": "Ausgesate geschniddene Koffer",
  "block.minecraft.exposed_cut_copper_slab": "Ausgesat geschnidde Kofferplack",
  "block.minecraft.exposed_cut_copper_stairs": "Gewuesst geschnidde Koffertrap",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Feld",
  "block.minecraft.fern": "Far",
  "block.minecraft.fire": "Feier",
  "block.minecraft.fire_coral": "Féierkorall",
  "block.minecraft.fire_coral_block": "Féierkoralleblock",
  "block.minecraft.fire_coral_fan": "Féierkorallefächer",
  "block.minecraft.fire_coral_wall_fan": "Féierkorallemauerfächer",
  "block.minecraft.firefly_bush": "Gehaansfénkelchebusch",
  "block.minecraft.fletching_table": "Bouspanndësch",
  "block.minecraft.flower_pot": "Blummendëppen",
  "block.minecraft.flowering_azalea": "Gebléine Azalee",
  "block.minecraft.flowering_azalea_leaves": "Bléiend Azaleëblieder",
  "block.minecraft.frogspawn": "Kauzekapp",
  "block.minecraft.frosted_ice": "Sprockt Eis",
  "block.minecraft.furnace": "Uewen",
  "block.minecraft.gilded_blackstone": "Gëllenen Schwaarzsteen",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasscheif",
  "block.minecraft.glow_lichen": "Liichtflechten",
  "block.minecraft.glowstone": "Liichtsteen",
  "block.minecraft.gold_block": "Goldblock",
  "block.minecraft.gold_ore": "Goldäerz",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitplack",
  "block.minecraft.granite_stairs": "Granittrap",
  "block.minecraft.granite_wall": "Granitmauer",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Gras",
  "block.minecraft.gravel": "Kräsi",
  "block.minecraft.gray_banner": "Groe Fändel",
  "block.minecraft.gray_bed": "Grot Bett",
  "block.minecraft.gray_candle": "Gro Käerz",
  "block.minecraft.gray_candle_cake": "Kuch mat groer Käerz",
  "block.minecraft.gray_carpet": "Groen Teppech",
  "block.minecraft.gray_concrete": "Groe Bëtong",
  "block.minecraft.gray_concrete_powder": "Groen Zement",
  "block.minecraft.gray_glazed_terracotta": "Glaséiert gro Keramik",
  "block.minecraft.gray_shulker_box": "Gro Shulker-Këscht",
  "block.minecraft.gray_stained_glass": "Grot Glas",
  "block.minecraft.gray_stained_glass_pane": "Gro Glasscheif",
  "block.minecraft.gray_terracotta": "Gro Keramik",
  "block.minecraft.gray_wool": "Gro Woll",
  "block.minecraft.green_banner": "Grénge Fändel",
  "block.minecraft.green_bed": "Gréngt Bett",
  "block.minecraft.green_candle": "Gréng Käerz",
  "block.minecraft.green_candle_cake": "Kuch mat grénger Käerz",
  "block.minecraft.green_carpet": "Gréngen Teppech",
  "block.minecraft.green_concrete": "Grénge Bëtong",
  "block.minecraft.green_concrete_powder": "Gréngen Zement",
  "block.minecraft.green_glazed_terracotta": "Glaséiert gréng Keramik",
  "block.minecraft.green_shulker_box": "Gréng Shulker-Këscht",
  "block.minecraft.green_stained_glass": "Gréngt Glas",
  "block.minecraft.green_stained_glass_pane": "Gréng Glasscheif",
  "block.minecraft.green_terracotta": "Gréng Keramik",
  "block.minecraft.green_wool": "Gréng Woll",
  "block.minecraft.grindstone": "Schläifsteen",
  "block.minecraft.hanging_roots": "Hängend Wuerzelen",
  "block.minecraft.hay_block": "Bott",
  "block.minecraft.heavy_core": "Schwéiere Kär",
  "block.minecraft.heavy_weighted_pressure_plate": "Schwéier gewiichtet Drockplack",
  "block.minecraft.honey_block": "Hunnegblock",
  "block.minecraft.honeycomb_block": "Hunnegwabeblock",
  "block.minecraft.hopper": "Triichter",
  "block.minecraft.horn_coral": "Geweikorall",
  "block.minecraft.horn_coral_block": "Geweikoralleblock",
  "block.minecraft.horn_coral_fan": "Geweikorallefächer",
  "block.minecraft.horn_coral_wall_fan": "Geweikorallemauerfächer",
  "block.minecraft.ice": "Äis",
  "block.minecraft.infested_chiseled_stone_bricks": "Befale gemeesselt Steenzillen",
  "block.minecraft.infested_cobblestone": "Befalene Brochsteen",
  "block.minecraft.infested_cracked_stone_bricks": "Befale rësseg Steenzillen",
  "block.minecraft.infested_deepslate": "Befalenen Déiweschifer",
  "block.minecraft.infested_mossy_stone_bricks": "Befal bemoosst Steenzillen",
  "block.minecraft.infested_stone": "Befalene Steen",
  "block.minecraft.infested_stone_bricks": "Befale Steenzillen",
  "block.minecraft.iron_bars": "Eisegitter",
  "block.minecraft.iron_block": "Eiseblock",
  "block.minecraft.iron_chain": "Eiseketten",
  "block.minecraft.iron_door": "Eisendier",
  "block.minecraft.iron_ore": "Eisenäerz",
  "block.minecraft.iron_trapdoor": "Eiseklappdier",
  "block.minecraft.jack_o_lantern": "Kürbislanter",
  "block.minecraft.jigsaw": "Puzzleblock",
  "block.minecraft.jukebox": "Plackespiller",
  "block.minecraft.jungle_button": "Tropenholzknäppchen",
  "block.minecraft.jungle_door": "Tropenholzdier",
  "block.minecraft.jungle_fence": "Tropenholzzonk",
  "block.minecraft.jungle_fence_gate": "Tropenholzzonkpaart",
  "block.minecraft.jungle_hanging_sign": "Tropenholzhängeschëld",
  "block.minecraft.jungle_leaves": "Tropeblieder",
  "block.minecraft.jungle_log": "Tropenholzstamm",
  "block.minecraft.jungle_planks": "Tropenholzbrieder",
  "block.minecraft.jungle_pressure_plate": "Tropenholzdrockplack",
  "block.minecraft.jungle_sapling": "Tropesetzlek",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Tropenholzschëld",
  "block.minecraft.jungle_slab": "Tropenholzplack",
  "block.minecraft.jungle_stairs": "Tropenholztrap",
  "block.minecraft.jungle_trapdoor": "Tropenholzklappdier",
  "block.minecraft.jungle_wall_hanging_sign": "Tropeholzmauerhängeschëld",
  "block.minecraft.jungle_wall_sign": "Tropenholzmauerschëld",
  "block.minecraft.jungle_wood": "Tropenholz",
  "block.minecraft.kelp": "Alg",
  "block.minecraft.kelp_plant": "Algestill",
  "block.minecraft.ladder": "Leeder",
  "block.minecraft.lantern": "Lanter",
  "block.minecraft.lapis_block": "Lapislazuliblock",
  "block.minecraft.lapis_ore": "Lapislazuliäerz",
  "block.minecraft.large_amethyst_bud": "Grouss Amethystknosp",
  "block.minecraft.large_fern": "Grousse Far",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakessel",
  "block.minecraft.leaf_litter": "Lafkoup",
  "block.minecraft.lectern": "Liespult",
  "block.minecraft.lever": "Hiewel",
  "block.minecraft.light": "Luucht",
  "block.minecraft.light_blue_banner": "Hellbloe Fändel",
  "block.minecraft.light_blue_bed": "Hellblot Bett",
  "block.minecraft.light_blue_candle": "Hellblo Käerz",
  "block.minecraft.light_blue_candle_cake": "Kuch mat hellbloer Käerz",
  "block.minecraft.light_blue_carpet": "Hellbloen Teppech",
  "block.minecraft.light_blue_concrete": "Hellbloe Bëtong",
  "block.minecraft.light_blue_concrete_powder": "Hellbloen Zement",
  "block.minecraft.light_blue_glazed_terracotta": "Glaséiert hellblo Keramik",
  "block.minecraft.light_blue_shulker_box": "Hellblo Shulker-Këscht",
  "block.minecraft.light_blue_stained_glass": "Hellblot Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblo Glasscheif",
  "block.minecraft.light_blue_terracotta": "Hellblo Keramik",
  "block.minecraft.light_blue_wool": "Hellblo Woll",
  "block.minecraft.light_gray_banner": "Hellgroe Fändel",
  "block.minecraft.light_gray_bed": "Hellgrot Bett",
  "block.minecraft.light_gray_candle": "Hellgro Käerz",
  "block.minecraft.light_gray_candle_cake": "Kuch mat hellgroer Käerz",
  "block.minecraft.light_gray_carpet": "Hellgroen Teppech",
  "block.minecraft.light_gray_concrete": "Hellgroe Bëtong",
  "block.minecraft.light_gray_concrete_powder": "Hellgroen Zement",
  "block.minecraft.light_gray_glazed_terracotta": "Glaséiert hellgro Keramik",
  "block.minecraft.light_gray_shulker_box": "Hellgro Shulker-Këscht",
  "block.minecraft.light_gray_stained_glass": "Hellgrot Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgro Glasscheif",
  "block.minecraft.light_gray_terracotta": "Hellgro Keramik",
  "block.minecraft.light_gray_wool": "Hellgro Woll",
  "block.minecraft.light_weighted_pressure_plate": "Liicht gewiichtet Drockplack",
  "block.minecraft.lightning_rod": "Blëtzofleeder",
  "block.minecraft.lilac": "Neelchesblumm",
  "block.minecraft.lily_of_the_valley": "Meeréischen",
  "block.minecraft.lily_pad": "Séirous",
  "block.minecraft.lime_banner": "Hellgrénge Fändel",
  "block.minecraft.lime_bed": "Hellgréngt Bett",
  "block.minecraft.lime_candle": "Hellgréng Käerz",
  "block.minecraft.lime_candle_cake": "Kuch mat hellgrénger Käerz",
  "block.minecraft.lime_carpet": "Hellgréngen Teppech",
  "block.minecraft.lime_concrete": "Hellgrénge Bëtong",
  "block.minecraft.lime_concrete_powder": "Hellgréngen Zement",
  "block.minecraft.lime_glazed_terracotta": "Glaséiert hellgréng Keramik",
  "block.minecraft.lime_shulker_box": "Hellgréng Shulker-Këscht",
  "block.minecraft.lime_stained_glass": "Hellgréngt Glas",
  "block.minecraft.lime_stained_glass_pane": "Hellgréng Glasscheif",
  "block.minecraft.lime_terracotta": "Hellgréng Keramik",
  "block.minecraft.lime_wool": "Hellgréng Woll",
  "block.minecraft.lodestone": "Leetsteen",
  "block.minecraft.loom": "Wiefstull",
  "block.minecraft.magenta_banner": "Magentae Fändel",
  "block.minecraft.magenta_bed": "Magentat Bett",
  "block.minecraft.magenta_candle": "Magenta Käerz",
  "block.minecraft.magenta_candle_cake": "Kuch mat mofer Käerz",
  "block.minecraft.magenta_carpet": "Magentaen Teppech",
  "block.minecraft.magenta_concrete": "Magentae Bëtong",
  "block.minecraft.magenta_concrete_powder": "Magentaen Zement",
  "block.minecraft.magenta_glazed_terracotta": "Glaséiert magenta Keramik",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker-Këscht",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glasscheif",
  "block.minecraft.magenta_terracotta": "Magenta Keramik",
  "block.minecraft.magenta_wool": "Magenta Woll",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangrouwenholzknäppchen",
  "block.minecraft.mangrove_door": "Mangrouwenholz",
  "block.minecraft.mangrove_fence": "Mangrouwenholzzonk",
  "block.minecraft.mangrove_fence_gate": "Mangrouwenholzzonkpaart",
  "block.minecraft.mangrove_hanging_sign": "Mangrouwenholzhängeschëld",
  "block.minecraft.mangrove_leaves": "Mangrouweblieder",
  "block.minecraft.mangrove_log": "Mangrouwestamm",
  "block.minecraft.mangrove_planks": "Mangrouwenholzplack",
  "block.minecraft.mangrove_pressure_plate": "Mangrouwendrockplack",
  "block.minecraft.mangrove_propagule": "Mangrouwen-Keimling",
  "block.minecraft.mangrove_roots": "Mangrouwewuerzelen",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrouwenholzschëld",
  "block.minecraft.mangrove_slab": "Mangrouwenholzplack",
  "block.minecraft.mangrove_stairs": "Mangrouwenholztrap",
  "block.minecraft.mangrove_trapdoor": "Mangrouwenholzklappdier",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrouwewandhängeschëld",
  "block.minecraft.mangrove_wall_sign": "Mangrouwenholzwandschëld",
  "block.minecraft.mangrove_wood": "Mangrouwenholz",
  "block.minecraft.medium_amethyst_bud": "Medium Amethystknosp",
  "block.minecraft.melon": "Meloun",
  "block.minecraft.melon_stem": "Melouneplanz",
  "block.minecraft.moss_block": "Moosblock",
  "block.minecraft.moss_carpet": "Moosteppech",
  "block.minecraft.mossy_cobblestone": "Bemoosste Brochsteen",
  "block.minecraft.mossy_cobblestone_slab": "Bemooste Brochsteeplack",
  "block.minecraft.mossy_cobblestone_stairs": "Bemooste Brochsteentrap",
  "block.minecraft.mossy_cobblestone_wall": "Bemoosste Brochsteemauer",
  "block.minecraft.mossy_stone_brick_slab": "Bemooste Steenzilleplack",
  "block.minecraft.mossy_stone_brick_stairs": "Bemoost Steenzillentrap",
  "block.minecraft.mossy_stone_brick_wall": "Bemooste Steenzillemauer",
  "block.minecraft.mossy_stone_bricks": "Bemoosst Steenzillen",
  "block.minecraft.moving_piston": "Block a Beweegung",
  "block.minecraft.mud": "Bulli",
  "block.minecraft.mud_brick_slab": "Bullizilleplack",
  "block.minecraft.mud_brick_stairs": "Bullizilletrap",
  "block.minecraft.mud_brick_wall": "Bullizillemauer",
  "block.minecraft.mud_bricks": "Bulliszillen",
  "block.minecraft.muddy_mangrove_roots": "Schmorreg Mangrouwewuerzelen",
  "block.minecraft.mushroom_stem": "Champignongsstill",
  "block.minecraft.mycelium": "Pilzgeflecht",
  "block.minecraft.nether_brick_fence": "Netherzillenzonk",
  "block.minecraft.nether_brick_slab": "Netherzilleplack",
  "block.minecraft.nether_brick_stairs": "Netherzillentrap",
  "block.minecraft.nether_brick_wall": "Netherzillemauer",
  "block.minecraft.nether_bricks": "Netherzillen",
  "block.minecraft.nether_gold_ore": "Nethergoldäerz",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherquarzäerz",
  "block.minecraft.nether_sprouts": "Nethersprossen",
  "block.minecraft.nether_wart": "Netherwaarzel",
  "block.minecraft.nether_wart_block": "Netherwaarzelblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nouteblock",
  "block.minecraft.oak_button": "Eechenholzknäppchen",
  "block.minecraft.oak_door": "Eechenholzdier",
  "block.minecraft.oak_fence": "Eechenholzzonk",
  "block.minecraft.oak_fence_gate": "Eechenholzzonkpaart",
  "block.minecraft.oak_hanging_sign": "Eechenholzhängeschëld",
  "block.minecraft.oak_leaves": "Eecheblieder",
  "block.minecraft.oak_log": "Eechestamm",
  "block.minecraft.oak_planks": "Eechenholzbrieder",
  "block.minecraft.oak_pressure_plate": "Eechenholzdrockplack",
  "block.minecraft.oak_sapling": "Eechesetzlek",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Eechenholzschëld",
  "block.minecraft.oak_slab": "Eechenholzplack",
  "block.minecraft.oak_stairs": "Eechenholztrap",
  "block.minecraft.oak_trapdoor": "Eechenholzklappdier",
  "block.minecraft.oak_wall_hanging_sign": "Eechenholzwandhängeschëld",
  "block.minecraft.oak_wall_sign": "Eechenholzmauerschëld",
  "block.minecraft.oak_wood": "Eechenholz",
  "block.minecraft.observer": "Observateur",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ocker Fräschluucht",
  "block.minecraft.ominous_banner": "Ominéise Fändel",
  "block.minecraft.open_eyeblossom": "Oppen Ablumm",
  "block.minecraft.orange_banner": "Orange Fändel",
  "block.minecraft.orange_bed": "Oranget Bett",
  "block.minecraft.orange_candle": "Orange Käerz",
  "block.minecraft.orange_candle_cake": "Kuch mat oranger Käerz",
  "block.minecraft.orange_carpet": "Orangen Teppech",
  "block.minecraft.orange_concrete": "Orangë Bëtong",
  "block.minecraft.orange_concrete_powder": "Orangen Zement",
  "block.minecraft.orange_glazed_terracotta": "Glaséiert orange Keramik",
  "block.minecraft.orange_shulker_box": "Orange Shulker-Këscht",
  "block.minecraft.orange_stained_glass": "Orange Glas",
  "block.minecraft.orange_stained_glass_pane": "Orange Glasscheif",
  "block.minecraft.orange_terracotta": "Orange Keramik",
  "block.minecraft.orange_tulip": "Orange Tulp",
  "block.minecraft.orange_wool": "Orange Woll",
  "block.minecraft.oxeye_daisy": "Margréitchen",
  "block.minecraft.oxidized_chiseled_copper": "Oxidéierte geneesselte Kofferblock",
  "block.minecraft.oxidized_copper": "Oxidéierte Kofferblock",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidéiert Kofferbier",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidéiert Kofferdier",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidéierte Koffergitter",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidéiert Kofferklappdier",
  "block.minecraft.oxidized_cut_copper": "Oxidéierte geschniddene Kofferblock",
  "block.minecraft.oxidized_cut_copper_slab": "Gewuesst geschnidde Kofferplack",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidéiert geschnidde Koffertrap",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Packäis",
  "block.minecraft.packed_mud": "Feste Bulli",
  "block.minecraft.pale_hanging_moss": "Hängende Blatzmoos",
  "block.minecraft.pale_moss_block": "Blatzmoosblock",
  "block.minecraft.pale_moss_carpet": "Blatzmoosteppech",
  "block.minecraft.pale_oak_button": "Blatzeechenholzknäppchen",
  "block.minecraft.pale_oak_door": "Blatzeechenholzdier",
  "block.minecraft.pale_oak_fence": "Blatzeechenholzzonk",
  "block.minecraft.pale_oak_fence_gate": "Blatzeechenholzzonkpaart",
  "block.minecraft.pale_oak_hanging_sign": "Blatzeechenholzhängeschëld",
  "block.minecraft.pale_oak_leaves": "Blatzeechelaub",
  "block.minecraft.pale_oak_log": "Blatzeechestamm",
  "block.minecraft.pale_oak_planks": "Blatzeechenholzbrieder",
  "block.minecraft.pale_oak_pressure_plate": "Blatzeechenholzdrockplack",
  "block.minecraft.pale_oak_sapling": "Blatzeechesetzleck",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Blatzeechenholzschëld",
  "block.minecraft.pale_oak_slab": "Blatzeechenholzplack",
  "block.minecraft.pale_oak_stairs": "Blatzeechenholztrap",
  "block.minecraft.pale_oak_trapdoor": "Blatzeechenholzklappdier",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blatzeechenholzwandhängeschëld",
  "block.minecraft.pale_oak_wall_sign": "Blatzeechenholzwandschëld",
  "block.minecraft.pale_oak_wood": "Blatzeechenholz",
  "block.minecraft.pearlescent_froglight": "Pärelmudd Fräschluucht",
  "block.minecraft.peony": "Päischtrous",
  "block.minecraft.petrified_oak_slab": "Verstengert Eechenholzplack",
  "block.minecraft.piglin_head": "Piglinkapp",
  "block.minecraft.piglin_wall_head": "Piglin-Mauerkapp",
  "block.minecraft.pink_banner": "Rosae Fändel",
  "block.minecraft.pink_bed": "Rosat Bett",
  "block.minecraft.pink_candle": "Rosa Käerz",
  "block.minecraft.pink_candle_cake": "Kuch mat rosa Käerz",
  "block.minecraft.pink_carpet": "Rosaen Teppech",
  "block.minecraft.pink_concrete": "Rosae Bëtong",
  "block.minecraft.pink_concrete_powder": "Rosaen Zement",
  "block.minecraft.pink_glazed_terracotta": "Glaséiert rosa Keramik",
  "block.minecraft.pink_petals": "Rosa Bléieblieder",
  "block.minecraft.pink_shulker_box": "Rosa Shulker-Këscht",
  "block.minecraft.pink_stained_glass": "Rosat Glas",
  "block.minecraft.pink_stained_glass_pane": "Rosa Glasscheif",
  "block.minecraft.pink_terracotta": "Rosa Keramik",
  "block.minecraft.pink_tulip": "Rosa Tulp",
  "block.minecraft.pink_wool": "Rosa Woll",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Kapp vum Piston",
  "block.minecraft.pitcher_crop": "Kaneplanzentrieb",
  "block.minecraft.pitcher_plant": "Kaneplanz",
  "block.minecraft.player_head": "Spillerkapp",
  "block.minecraft.player_head.named": "Dem %s säi Kapp",
  "block.minecraft.player_wall_head": "Spillermauerkapp",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spëtzen Drëpssteen",
  "block.minecraft.polished_andesite": "Poléierten Andesit",
  "block.minecraft.polished_andesite_slab": "Poléiert Andesitplack",
  "block.minecraft.polished_andesite_stairs": "Poléiert Andesittrap",
  "block.minecraft.polished_basalt": "Poléierte Basalt",
  "block.minecraft.polished_blackstone": "Poléierten Schwaarzsteen",
  "block.minecraft.polished_blackstone_brick_slab": "Poléiert Schwaarzsteenzilleplack",
  "block.minecraft.polished_blackstone_brick_stairs": "Poléiert Schwaarzsteenzillentrap",
  "block.minecraft.polished_blackstone_brick_wall": "Poléiert Schwarzsteenzillemauer",
  "block.minecraft.polished_blackstone_bricks": "Poléiert Schwarzsteenzillen",
  "block.minecraft.polished_blackstone_button": "Poléierte Schwaarzsteeknäppchen",
  "block.minecraft.polished_blackstone_pressure_plate": "Poléiert Schwaarzsteendrockplack",
  "block.minecraft.polished_blackstone_slab": "Poléiert Schwaarzsteeplack",
  "block.minecraft.polished_blackstone_stairs": "Poléiert Schwaarzsteentrap",
  "block.minecraft.polished_blackstone_wall": "Poléiert Schwaarzsteenmauer",
  "block.minecraft.polished_deepslate": "Poléierten Déiweschifer",
  "block.minecraft.polished_deepslate_slab": "Poléierten Déiweschiferplack",
  "block.minecraft.polished_deepslate_stairs": "Poléierten Déiweschifertrap",
  "block.minecraft.polished_deepslate_wall": "Poléierten Déiweschifermauer",
  "block.minecraft.polished_diorite": "Poléierten Diorit",
  "block.minecraft.polished_diorite_slab": "Poléiert Dioritplack",
  "block.minecraft.polished_diorite_stairs": "Poléiert Diorittrap",
  "block.minecraft.polished_granite": "Poléierte Granit",
  "block.minecraft.polished_granite_slab": "Poléiert Granitplack",
  "block.minecraft.polished_granite_stairs": "Poléiert Granittrap",
  "block.minecraft.polished_tuff": "Poléiert Trass",
  "block.minecraft.polished_tuff_slab": "Poléiert Trassplack",
  "block.minecraft.polished_tuff_stairs": "Poléiert Trasstrap",
  "block.minecraft.polished_tuff_wall": "Poléiert Trassmauer",
  "block.minecraft.poppy": "Feierblumm",
  "block.minecraft.potatoes": "Gromperen",
  "block.minecraft.potted_acacia_sapling": "Akaziesetzlek an engem Dëppen",
  "block.minecraft.potted_allium": "Allium an engem Dëppen",
  "block.minecraft.potted_azalea_bush": "Azalee am Dëppen",
  "block.minecraft.potted_azure_bluet": "Porzeläinsstäerchen an engem Dëppen",
  "block.minecraft.potted_bamboo": "Bambus an engem Dëppen",
  "block.minecraft.potted_birch_sapling": "Bierkesetzlek an engem Dëppen",
  "block.minecraft.potted_blue_orchid": "Blo Orchidee an engem Dëppen",
  "block.minecraft.potted_brown_mushroom": "Bronge Champignon an engem Dëppen",
  "block.minecraft.potted_cactus": "Kaktus an engem Dëppen",
  "block.minecraft.potted_cherry_sapling": "Kiischtesetzleng am Dëppen",
  "block.minecraft.potted_closed_eyeblossom": "Agedëppent zouen Ablumm",
  "block.minecraft.potted_cornflower": "Karblumm an engem Dëppen",
  "block.minecraft.potted_crimson_fungus": "Agedëppte Karmesin Champignon",
  "block.minecraft.potted_crimson_roots": "Agedëppte Karmesinwuerzelen",
  "block.minecraft.potted_dandelion": "Bettseechesch an engem Dëppen",
  "block.minecraft.potted_dark_oak_sapling": "Schwaarzeechesetzlek an engem Dëppen",
  "block.minecraft.potted_dead_bush": "Ofgestuerwene Strauch an engem Dëppen",
  "block.minecraft.potted_fern": "Far an engem Dëppen",
  "block.minecraft.potted_flowering_azalea_bush": "Bléiend Azalee am Dëppen",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Tropesetzlek an engem Dëppen",
  "block.minecraft.potted_lily_of_the_valley": "Meeréischen an engem Dëppen",
  "block.minecraft.potted_mangrove_propagule": "Mangrouwen-Keimling am Dëppen",
  "block.minecraft.potted_oak_sapling": "Eechesetzlek an engem Dëppen",
  "block.minecraft.potted_open_eyeblossom": "Agedëppent oppen Ablumm",
  "block.minecraft.potted_orange_tulip": "Orange Tulp an engem Dëppen",
  "block.minecraft.potted_oxeye_daisy": "Margréitchen an engem Dëppen",
  "block.minecraft.potted_pale_oak_sapling": "Agedëppente Blatzeechesetzléck",
  "block.minecraft.potted_pink_tulip": "Rosa Tulp an engem Dëppen",
  "block.minecraft.potted_poppy": "Feierblumm an engem Dëppen",
  "block.minecraft.potted_red_mushroom": "Roude Champignon an engem Dëppen",
  "block.minecraft.potted_red_tulip": "Rout Tulp an engem Dëppen",
  "block.minecraft.potted_spruce_sapling": "Fiichtesetzlek an engem Dëppen",
  "block.minecraft.potted_torchflower": "Karblumm am Dëppen",
  "block.minecraft.potted_warped_fungus": "Verduerwene Champignon am Dëppen",
  "block.minecraft.potted_warped_roots": "Verduerwe Wuerzelen am Dëppen",
  "block.minecraft.potted_white_tulip": "Wäiss Tulp an engem Dëppen",
  "block.minecraft.potted_wither_rose": "Witherrous an engem Dëppen",
  "block.minecraft.powder_snow": "Polverschnéi",
  "block.minecraft.powder_snow_cauldron": "Polverschnéikessel",
  "block.minecraft.powered_rail": "Beschleunegungsschinn",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinzilleplack",
  "block.minecraft.prismarine_brick_stairs": "Prismarinzillentrap",
  "block.minecraft.prismarine_bricks": "Prismarinzillen",
  "block.minecraft.prismarine_slab": "Prismarinplack",
  "block.minecraft.prismarine_stairs": "Prismarintrap",
  "block.minecraft.prismarine_wall": "Prismarinmauer",
  "block.minecraft.pumpkin": "Kürbis",
  "block.minecraft.pumpkin_stem": "Kürbisstill",
  "block.minecraft.purple_banner": "Mofe Fändel",
  "block.minecraft.purple_bed": "Mooft Bett",
  "block.minecraft.purple_candle": "Mof Käerz",
  "block.minecraft.purple_candle_cake": "Kuch mat mofer Käerz",
  "block.minecraft.purple_carpet": "Mofen Teppech",
  "block.minecraft.purple_concrete": "Mofe Bëtong",
  "block.minecraft.purple_concrete_powder": "Mofen Zement",
  "block.minecraft.purple_glazed_terracotta": "Glaséiert mof Keramik",
  "block.minecraft.purple_shulker_box": "Mof Shulker-Këscht",
  "block.minecraft.purple_stained_glass": "Moft Glas",
  "block.minecraft.purple_stained_glass_pane": "Mof Glasscheif",
  "block.minecraft.purple_terracotta": "Mof Keramik",
  "block.minecraft.purple_wool": "Mof Woll",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpursail",
  "block.minecraft.purpur_slab": "Purpurträpplek",
  "block.minecraft.purpur_stairs": "Purpurtrap",
  "block.minecraft.quartz_block": "Quarzblock",
  "block.minecraft.quartz_bricks": "Quarzzillen",
  "block.minecraft.quartz_pillar": "Quarzsail",
  "block.minecraft.quartz_slab": "Quarzplack",
  "block.minecraft.quartz_stairs": "Quarztrap",
  "block.minecraft.rail": "Schinn",
  "block.minecraft.raw_copper_block": "Réikofferblock",
  "block.minecraft.raw_gold_block": "Réigoldblock",
  "block.minecraft.raw_iron_block": "Réieiseblock",
  "block.minecraft.red_banner": "Roude Fändel",
  "block.minecraft.red_bed": "Rout Bett",
  "block.minecraft.red_candle": "Rout Käerz",
  "block.minecraft.red_candle_cake": "Kuch mat rouder Käerz",
  "block.minecraft.red_carpet": "Rouden Teppech",
  "block.minecraft.red_concrete": "Roude Bëtong",
  "block.minecraft.red_concrete_powder": "Rouden Zement",
  "block.minecraft.red_glazed_terracotta": "Glaséiert rout Keramik",
  "block.minecraft.red_mushroom": "Roude Champignon",
  "block.minecraft.red_mushroom_block": "Roude Champignonblock",
  "block.minecraft.red_nether_brick_slab": "Rout Netherzilleplack",
  "block.minecraft.red_nether_brick_stairs": "Rout Netherzillentrap",
  "block.minecraft.red_nether_brick_wall": "Rout Netherzillemauer",
  "block.minecraft.red_nether_bricks": "Roud Netherzillen",
  "block.minecraft.red_sand": "Roude Sand",
  "block.minecraft.red_sandstone": "Roude Sandsteen",
  "block.minecraft.red_sandstone_slab": "Rout Sandsteeplack",
  "block.minecraft.red_sandstone_stairs": "Rout Sandsteentrap",
  "block.minecraft.red_sandstone_wall": "Rout Standsteemauer",
  "block.minecraft.red_shulker_box": "Rout Shulker-Këscht",
  "block.minecraft.red_stained_glass": "Rout Glas",
  "block.minecraft.red_stained_glass_pane": "Roud Glasscheif",
  "block.minecraft.red_terracotta": "Rout Keramik",
  "block.minecraft.red_tulip": "Rout Tulp",
  "block.minecraft.red_wool": "Rout Woll",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Luucht",
  "block.minecraft.redstone_ore": "Redstone-Äerz",
  "block.minecraft.redstone_torch": "Redstone-Fakel",
  "block.minecraft.redstone_wall_torch": "Redstone-Mauerfakel",
  "block.minecraft.redstone_wire": "Redstone-Kabel",
  "block.minecraft.reinforced_deepslate": "Verstärkten Déiweschifer",
  "block.minecraft.repeater": "Redstone-Verstäerker",
  "block.minecraft.repeating_command_block": "Widderhuelungs Befehlsblock",
  "block.minecraft.resin_block": "Harzblock",
  "block.minecraft.resin_brick_slab": "Harzzilleplack",
  "block.minecraft.resin_brick_stairs": "Harzzilletrap",
  "block.minecraft.resin_brick_wall": "Harzzillemauer",
  "block.minecraft.resin_bricks": "Harzzill",
  "block.minecraft.resin_clump": "Harzklompen",
  "block.minecraft.respawn_anchor": "Séilenanker",
  "block.minecraft.rooted_dirt": "Wuerzeleärd",
  "block.minecraft.rose_bush": "Rousenheck",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandsteen",
  "block.minecraft.sandstone_slab": "Sandsteeplack",
  "block.minecraft.sandstone_stairs": "Sandsteentrap",
  "block.minecraft.sandstone_wall": "Sandsteemauer",
  "block.minecraft.scaffolding": "Gerüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kräischer",
  "block.minecraft.sculk_vein": "Sculk-Veen",
  "block.minecraft.sea_lantern": "Séilanter",
  "block.minecraft.sea_pickle": "Miereskornischong",
  "block.minecraft.seagrass": "Séigras",
  "block.minecraft.set_spawn": "Respawnpunkt gesat",
  "block.minecraft.short_dry_grass": "Niddregt Dréchegras",
  "block.minecraft.short_grass": "Kuerz Wiss",
  "block.minecraft.shroomlight": "Champignonluucht",
  "block.minecraft.shulker_box": "Shulker-Këscht",
  "block.minecraft.skeleton_skull": "Skelettkapp",
  "block.minecraft.skeleton_wall_skull": "Mauerskelettkapp",
  "block.minecraft.slime_block": "Schläimblock",
  "block.minecraft.small_amethyst_bud": "Kleng Amethystknosp",
  "block.minecraft.small_dripleaf": "Klengt Drëpsblaat",
  "block.minecraft.smithing_table": "Schmadddësch",
  "block.minecraft.smoker": "Reecheruewen",
  "block.minecraft.smooth_basalt": "Glate Basalt",
  "block.minecraft.smooth_quartz": "Glate Quarzblock",
  "block.minecraft.smooth_quartz_slab": "Glat Quarzplack",
  "block.minecraft.smooth_quartz_stairs": "Glat Quarztrap",
  "block.minecraft.smooth_red_sandstone": "Glate roude Sandsteen",
  "block.minecraft.smooth_red_sandstone_slab": "Glat rout Sandsteeplack",
  "block.minecraft.smooth_red_sandstone_stairs": "Glat rout Sandsteentrap",
  "block.minecraft.smooth_sandstone": "Glate Sandsteen",
  "block.minecraft.smooth_sandstone_slab": "Glat Sandsteeplack",
  "block.minecraft.smooth_sandstone_stairs": "Glat Steentrap",
  "block.minecraft.smooth_stone": "Glate Steen",
  "block.minecraft.smooth_stone_slab": "Glat Steeplack",
  "block.minecraft.sniffer_egg": "Schnoffeler-Ee",
  "block.minecraft.snow": "Schnéi",
  "block.minecraft.snow_block": "Schnéiblock",
  "block.minecraft.soul_campfire": "Séilelagerfeier",
  "block.minecraft.soul_fire": "Séilefeier",
  "block.minecraft.soul_lantern": "Séilelanter",
  "block.minecraft.soul_sand": "Séilesand",
  "block.minecraft.soul_soil": "Séilebuedem",
  "block.minecraft.soul_torch": "Séilefakel",
  "block.minecraft.soul_wall_torch": "Séilemauerfakel",
  "block.minecraft.spawn.not_valid": "Du hues kee Bett oder opgeluedene Séilenanker, oder en gouf blockéiert",
  "block.minecraft.spawner": "Spawner",
  "block.minecraft.spawner.desc1": "Benotz Spawn-Ee:",
  "block.minecraft.spawner.desc2": "Leet Kreaturetyp fest",
  "block.minecraft.sponge": "Schwamp",
  "block.minecraft.spore_blossom": "Sporebléi",
  "block.minecraft.spruce_button": "Fiichtenholzknäppchen",
  "block.minecraft.spruce_door": "Fiichtenholzdier",
  "block.minecraft.spruce_fence": "Fiichtenholzzonk",
  "block.minecraft.spruce_fence_gate": "Fiichtenholzzonkpaart",
  "block.minecraft.spruce_hanging_sign": "Fiichteholzhängeschëld",
  "block.minecraft.spruce_leaves": "Fiichtennolen",
  "block.minecraft.spruce_log": "Fiichtestamm",
  "block.minecraft.spruce_planks": "Fiichtenholzbrieder",
  "block.minecraft.spruce_pressure_plate": "Fiichtenholzdrockplack",
  "block.minecraft.spruce_sapling": "Fiichtesetzlek",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Fiichtenholzschëld",
  "block.minecraft.spruce_slab": "Fiichtenholzplack",
  "block.minecraft.spruce_stairs": "Fiichtenholztrap",
  "block.minecraft.spruce_trapdoor": "Fiichtenholzklappdier",
  "block.minecraft.spruce_wall_hanging_sign": "Fiichtemauerhängeschëld",
  "block.minecraft.spruce_wall_sign": "Fiichtenholzmauerschëld",
  "block.minecraft.spruce_wood": "Fiichtenholz",
  "block.minecraft.sticky_piston": "Pechege Piston",
  "block.minecraft.stone": "Steen",
  "block.minecraft.stone_brick_slab": "Steenzilleplack",
  "block.minecraft.stone_brick_stairs": "Steenzillentrap",
  "block.minecraft.stone_brick_wall": "Steenzillemauer",
  "block.minecraft.stone_bricks": "Steenzillen",
  "block.minecraft.stone_button": "Steeknäppchen",
  "block.minecraft.stone_pressure_plate": "Steendrockplack",
  "block.minecraft.stone_slab": "Steeplack",
  "block.minecraft.stone_stairs": "Steentrap",
  "block.minecraft.stonecutter": "Steesee",
  "block.minecraft.stripped_acacia_log": "Akaziëstamm ouni Schuel",
  "block.minecraft.stripped_acacia_wood": "Akazienholz ouni Schuel",
  "block.minecraft.stripped_bamboo_block": "Geschielte Bambusblock",
  "block.minecraft.stripped_birch_log": "Bierkestamm ouni Schuel",
  "block.minecraft.stripped_birch_wood": "Bierkenholz ouni Schuel",
  "block.minecraft.stripped_cherry_log": "Kiischtestamm ouni Schuel",
  "block.minecraft.stripped_cherry_wood": "Kiischtenholz ouni Schuel",
  "block.minecraft.stripped_crimson_hyphae": "Geschielte Karmesinhyphen",
  "block.minecraft.stripped_crimson_stem": "Geschielte Karmesinstill",
  "block.minecraft.stripped_dark_oak_log": "Schwaarzeechestamm ouni Schuel",
  "block.minecraft.stripped_dark_oak_wood": "Schwaarzeechenholz ouni Schuel",
  "block.minecraft.stripped_jungle_log": "Tropestamm ouni Schuel",
  "block.minecraft.stripped_jungle_wood": "Tropenholz ouni Schuel",
  "block.minecraft.stripped_mangrove_log": "Mangrouwestamm ouni Schuel",
  "block.minecraft.stripped_mangrove_wood": "Mangrouwenholz ouni Schuel",
  "block.minecraft.stripped_oak_log": "Eechestamm ouni Schuel",
  "block.minecraft.stripped_oak_wood": "Eechenholz ouni Schuel",
  "block.minecraft.stripped_pale_oak_log": "Blatzeechestamm ouni Schuel",
  "block.minecraft.stripped_pale_oak_wood": "Blatzeechenholz ouni Schuel",
  "block.minecraft.stripped_spruce_log": "Fiichtestamm ouni Schuel",
  "block.minecraft.stripped_spruce_wood": "Fiichtenholz ouni Schuel",
  "block.minecraft.stripped_warped_hyphae": "Geschielt verduerwen Hyphen",
  "block.minecraft.stripped_warped_stem": "Geschielte verduerwene Stamm",
  "block.minecraft.structure_block": "Konstruktiounsblock",
  "block.minecraft.structure_void": "Konstruktiounsvakuum",
  "block.minecraft.sugar_cane": "Zockerrouer",
  "block.minecraft.sunflower": "Sonneblumm",
  "block.minecraft.suspicious_gravel": "Verdächtege Kräsi",
  "block.minecraft.suspicious_sand": "Verdächtege Sand",
  "block.minecraft.sweet_berry_bush": "Séissbierestrauch",
  "block.minecraft.tall_dry_grass": "Héicht Dréchegras",
  "block.minecraft.tall_grass": "Héicht Gras",
  "block.minecraft.tall_seagrass": "Héicht Séigras",
  "block.minecraft.target": "Zielblock",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Pféifblock",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Getéint Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-Explosioune sinn desaktivéiert",
  "block.minecraft.torch": "Fakel",
  "block.minecraft.torchflower": "Karblumm",
  "block.minecraft.torchflower_crop": "Karblumm Baatsch",
  "block.minecraft.trapped_chest": "Falekëscht",
  "block.minecraft.trial_spawner": "Préifungs-Spawner",
  "block.minecraft.tripwire": "Faldrot",
  "block.minecraft.tripwire_hook": "Krop",
  "block.minecraft.tube_coral": "Uergelkorall",
  "block.minecraft.tube_coral_block": "Uergelkoralleblock",
  "block.minecraft.tube_coral_fan": "Uergelkorallefächer",
  "block.minecraft.tube_coral_wall_fan": "Uergelkorallemauerfächer",
  "block.minecraft.tuff": "Trass",
  "block.minecraft.tuff_brick_slab": "Trasszilleplack",
  "block.minecraft.tuff_brick_stairs": "Trasszillentrap",
  "block.minecraft.tuff_brick_wall": "Trasszillenmauer",
  "block.minecraft.tuff_bricks": "Trasszillen",
  "block.minecraft.tuff_slab": "Trassplack",
  "block.minecraft.tuff_stairs": "Trasstrap",
  "block.minecraft.tuff_wall": "Trassmauer",
  "block.minecraft.turtle_egg": "Schildkrötenee",
  "block.minecraft.twisting_vines": "Wéckellianen",
  "block.minecraft.twisting_vines_plant": "Wéckellianenplanz",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Gréng Fräschluucht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Loft vum Näischt",
  "block.minecraft.wall_torch": "Mauerfakel",
  "block.minecraft.warped_button": "Verduerwene Knäppchen",
  "block.minecraft.warped_door": "Verduerwen Dier",
  "block.minecraft.warped_fence": "Verduerwenen Zonk",
  "block.minecraft.warped_fence_gate": "Verduerwen Zonkpaart",
  "block.minecraft.warped_fungus": "Verduerwene Champignon",
  "block.minecraft.warped_hanging_sign": "Verduewend Hängeschëld",
  "block.minecraft.warped_hyphae": "Verduerwen Hyphen",
  "block.minecraft.warped_nylium": "Verduerwenen Nylium",
  "block.minecraft.warped_planks": "Verduerwe Brieder",
  "block.minecraft.warped_pressure_plate": "Verduerwen Drockplack",
  "block.minecraft.warped_roots": "Verduerwe Wuerzelen",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Verduerwend Schëld",
  "block.minecraft.warped_slab": "Verduerwe Plack",
  "block.minecraft.warped_stairs": "Verduerwen Trap",
  "block.minecraft.warped_stem": "Verduerwene Stamm",
  "block.minecraft.warped_trapdoor": "Verduerwen Klappdier",
  "block.minecraft.warped_wall_hanging_sign": "Verduewend Wandhängeschëld",
  "block.minecraft.warped_wall_sign": "Verduerwend Wandschëld",
  "block.minecraft.warped_wart_block": "Verduerwene Waarzelblock",
  "block.minecraft.water": "Waasser",
  "block.minecraft.water_cauldron": "Waasserkessel",
  "block.minecraft.waxed_chiseled_copper": "Gewuessten oxidéierte Kofferblock",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Gewuesste Kofferblock",
  "block.minecraft.waxed_copper_bulb": "Gewuesst Kofferbier",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Gewuesst Kofferdier",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Gewuesst Koffergitter",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Gewuesst Kofferklappdier",
  "block.minecraft.waxed_cut_copper": "Gewuesste geschniddene Kofferblock",
  "block.minecraft.waxed_cut_copper_slab": "Gewuesst geschnidde Kofferplack",
  "block.minecraft.waxed_cut_copper_stairs": "Gewuesst geschnidde Koffertrap",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gewuessten ausgesate gemeesselte Kofferblock",
  "block.minecraft.waxed_exposed_copper": "Gewuessten ausgesate Kofferblock",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewuesst ausgesat Kofferbier",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Gewuesst ausgesat Kofferdier",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Gewuesst ausgesat Koffergitter",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gewuesst ausgesat Kofferklappdier",
  "block.minecraft.waxed_exposed_cut_copper": "Gewuessten ausgesate geschniddene Kofferblock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gewuesst ausgesat geschnidde Kofferplack",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gewuesst ausgesat geschnidde Koffertrap",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gewuessten ausgesate gemeesselte Kofferblock",
  "block.minecraft.waxed_oxidized_copper": "Gewuessten oxidéierte Kofferblock",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gewuesst oxidéiert Kofferbier",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Gewuesst oxidéiert Kofferdier",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gewuesst oxidéiert Koffergitter",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gewuesst oxidéiert Kofferklappdier",
  "block.minecraft.waxed_oxidized_cut_copper": "Gewuessten oxidéierte geschniddene Kofferblock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gewuesst oxidéiert geschnidde Kofferplack",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gewuesst oxidéiert geschnidde Koffertrap",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gewuesste verwitterte gemeesselte Kofferblock",
  "block.minecraft.waxed_weathered_copper": "Gewuesste verwitterte Kofferblock",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Gewuesst verwittert Kofferbier",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Gewuesst verwittert Kofferdier",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Gewuesst verwittert Koffergitter",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gewuesst verwittert Kofferklappdier",
  "block.minecraft.waxed_weathered_cut_copper": "Gewuesste verwitterte geschniddene Kofferblock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gewuesst verwittert geschnidde Kofferplack",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gewuesst verwittert geschnidde Koffertrap",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Verwitterte gemeesselte Kofferblock",
  "block.minecraft.weathered_copper": "Verwitterte Kofferblock",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Verwittert Kofferbier",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Verwittert Kofferdier",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Verwittert Koffergitter",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Verwittert Kofferklappdier",
  "block.minecraft.weathered_cut_copper": "Verwitterte geschniddene Kofferblock",
  "block.minecraft.weathered_cut_copper_slab": "Verwittert geschnidde Kofferplack",
  "block.minecraft.weathered_cut_copper_stairs": "Verwittert geschnidde Koffertrap",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Trauerlianen",
  "block.minecraft.weeping_vines_plant": "Trauerlianenplanz",
  "block.minecraft.wet_sponge": "Naasse Schwamp",
  "block.minecraft.wheat": "Weessplanzen",
  "block.minecraft.white_banner": "Wäisse Fändel",
  "block.minecraft.white_bed": "Wäisst Bett",
  "block.minecraft.white_candle": "Wäiss Käerz",
  "block.minecraft.white_candle_cake": "Kuch mat wäisser Käerz",
  "block.minecraft.white_carpet": "Wäissen Teppech",
  "block.minecraft.white_concrete": "Wäisse Bëtong",
  "block.minecraft.white_concrete_powder": "Wäissen Zement",
  "block.minecraft.white_glazed_terracotta": "Glaséiert wäiss Keramik",
  "block.minecraft.white_shulker_box": "Wäiss Shulker-Këscht",
  "block.minecraft.white_stained_glass": "Wäisst Glas",
  "block.minecraft.white_stained_glass_pane": "Wäiss Glasscheif",
  "block.minecraft.white_terracotta": "Wäiss Keramik",
  "block.minecraft.white_tulip": "Wäiss Tulp",
  "block.minecraft.white_wool": "Wäiss Woll",
  "block.minecraft.wildflowers": "Wandblummen",
  "block.minecraft.wither_rose": "Witherrous",
  "block.minecraft.wither_skeleton_skull": "Witherskelettkapp",
  "block.minecraft.wither_skeleton_wall_skull": "Mauerwitherskelettkapp",
  "block.minecraft.yellow_banner": "Giele Fändel",
  "block.minecraft.yellow_bed": "Gielt Bett",
  "block.minecraft.yellow_candle": "Giel Käerz",
  "block.minecraft.yellow_candle_cake": "Kuch mat Gieler Käerz",
  "block.minecraft.yellow_carpet": "Gielen Teppech",
  "block.minecraft.yellow_concrete": "Giele Bëtong",
  "block.minecraft.yellow_concrete_powder": "Gielen Zement",
  "block.minecraft.yellow_glazed_terracotta": "Glaséiert giel Keramik",
  "block.minecraft.yellow_shulker_box": "Giel Shulker-Këscht",
  "block.minecraft.yellow_stained_glass": "Gielt Glas",
  "block.minecraft.yellow_stained_glass_pane": "Giel Glasscheif",
  "block.minecraft.yellow_terracotta": "Giel Keramik",
  "block.minecraft.yellow_wool": "Giel Woll",
  "block.minecraft.zombie_head": "Zombiekapp",
  "block.minecraft.zombie_wall_head": "Zombiemauerkapp",
  "item.minecraft.acacia_boat": "Akazienholzboot",
  "item.minecraft.acacia_chest_boat": "Akazienholzboot mat Këscht",
  "item.minecraft.allay_spawn_egg": "Hëllefsgeescht-Spawn-Ee",
  "item.minecraft.amethyst_shard": "Amethystschierbel",
  "item.minecraft.angler_pottery_shard": "Aangeler-Dëppeschierbel",
  "item.minecraft.angler_pottery_sherd": "Aangeler-Dëppeschierbel",
  "item.minecraft.apple": "Apel",
  "item.minecraft.archer_pottery_shard": "Schëtzen-Dëppeschierbel",
  "item.minecraft.archer_pottery_sherd": "Schëtzen-Dëppeschierbel",
  "item.minecraft.armadillo_scute": "Armadillo-Hornschëld",
  "item.minecraft.armadillo_spawn_egg": "Armadillo-Spawn-Ee",
  "item.minecraft.armor_stand": "Rüstungsstänner",
  "item.minecraft.arms_up_pottery_shard": "Gebärden-Dëppeschierbel",
  "item.minecraft.arms_up_pottery_sherd": "Gebärden-Dëppeschierbel",
  "item.minecraft.arrow": "Feil",
  "item.minecraft.axolotl_bucket": "Eemer mat Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ee",
  "item.minecraft.baked_potato": "Gebake Gromper",
  "item.minecraft.bamboo_chest_raft": "Bambusflooss",
  "item.minecraft.bamboo_raft": "Bambusflooss",
  "item.minecraft.bat_spawn_egg": "Flantermaus-Spawn-Ee",
  "item.minecraft.bee_spawn_egg": "Beie-Spawn-Ee",
  "item.minecraft.beef": "Réit Rëndfleesch",
  "item.minecraft.beetroot": "Rout Rommel",
  "item.minecraft.beetroot_seeds": "Rout Rommel Som",
  "item.minecraft.beetroot_soup": "Rout Rommel Zopp",
  "item.minecraft.birch_boat": "Bierkenholzboot",
  "item.minecraft.birch_chest_boat": "Bierkenholzboot mat Këscht",
  "item.minecraft.black_bundle": "Schwaarze Bëndel",
  "item.minecraft.black_dye": "Schwaarze Fuerfstoff",
  "item.minecraft.black_harness": "Schwaarzt Geschier",
  "item.minecraft.blade_pottery_shard": "Klengen-Dëppeschiebel",
  "item.minecraft.blade_pottery_sherd": "Klengen-Dëppeschiebel",
  "item.minecraft.blaze_powder": "Louestëbs",
  "item.minecraft.blaze_rod": "Louerutt",
  "item.minecraft.blaze_spawn_egg": "Lou-Spawn-Ee",
  "item.minecraft.blue_bundle": "Bloe Bëndel",
  "item.minecraft.blue_dye": "Bloe Fuerfstoff",
  "item.minecraft.blue_egg": "Blot Ee",
  "item.minecraft.blue_harness": "Blot Geschier",
  "item.minecraft.bogged_spawn_egg": "Sumpfskelett-Spawn-Ee",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolzen-Rüstungsbesaz",
  "item.minecraft.bone": "Schank",
  "item.minecraft.bone_meal": "Schankemiel",
  "item.minecraft.book": "Buch",
  "item.minecraft.bordure_indented_banner_pattern": "Bordür-Fändelvirlag",
  "item.minecraft.bow": "Bou",
  "item.minecraft.bowl": "Schossel",
  "item.minecraft.bread": "Brout",
  "item.minecraft.breeze_rod": "Breeze-Rutt",
  "item.minecraft.breeze_spawn_egg": "Breeze-Spawn-Ee",
  "item.minecraft.brewer_pottery_shard": "Brauer-Dëppeschierbel",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Dëppeschierbel",
  "item.minecraft.brewing_stand": "Braustand",
  "item.minecraft.brick": "Zill",
  "item.minecraft.brown_bundle": "Bronge Bëndel",
  "item.minecraft.brown_dye": "Bronge Fuerfstoff",
  "item.minecraft.brown_egg": "Brongt Ee",
  "item.minecraft.brown_harness": "Brongt Geschier",
  "item.minecraft.brush": "Biischt",
  "item.minecraft.bucket": "Eemer",
  "item.minecraft.bundle": "Bëndel",
  "item.minecraft.bundle.empty": "Eidel",
  "item.minecraft.bundle.empty.description": "Bitt Plaz fir e gemëschte Stapel vu Géigestänn",
  "item.minecraft.bundle.full": "Voll",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flamen-Dëppeschierbel",
  "item.minecraft.burn_pottery_sherd": "Flamen-Dëppeschierbel",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Kaméil-Spawn-Ee",
  "item.minecraft.carrot": "Muert",
  "item.minecraft.carrot_on_a_stick": "Muerterutt",
  "item.minecraft.cat_spawn_egg": "Kaze-Spawn-Ee",
  "item.minecraft.cauldron": "Kessel",
  "item.minecraft.cave_spider_spawn_egg": "Höhlespann-Spawn-Ee",
  "item.minecraft.chainmail_boots": "Kettestiwwelen",
  "item.minecraft.chainmail_chestplate": "Kettenhiem",
  "item.minecraft.chainmail_helmet": "Kettenhelm",
  "item.minecraft.chainmail_leggings": "Kettebox",
  "item.minecraft.charcoal": "Holzkuel",
  "item.minecraft.cherry_boat": "Kiischtenholzboot",
  "item.minecraft.cherry_chest_boat": "Kischtenholzboot mat Këscht",
  "item.minecraft.chest_minecart": "Gidderbuggi",
  "item.minecraft.chicken": "Réie Poulet",
  "item.minecraft.chicken_spawn_egg": "Hong-Spawn-Ee",
  "item.minecraft.chorus_fruit": "Chorusfruucht",
  "item.minecraft.clay_ball": "Tounklompen",
  "item.minecraft.clock": "Auer",
  "item.minecraft.coal": "Kuel",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Küsten-Rüstungsbesaz",
  "item.minecraft.cocoa_beans": "Kakaoboun",
  "item.minecraft.cod": "Réie Cabillaud",
  "item.minecraft.cod_bucket": "Cabillaudeemer",
  "item.minecraft.cod_spawn_egg": "Cabillaud-Spawn-Ee",
  "item.minecraft.command_block_minecart": "Befeelsblockbuggi",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Büfdeck",
  "item.minecraft.cooked_chicken": "Gebrodene Poulet",
  "item.minecraft.cooked_cod": "Gebrodene Cabillaud",
  "item.minecraft.cooked_mutton": "Gebrodent Hämmelsfleesch",
  "item.minecraft.cooked_porkchop": "Gebrodent Schwéngefleesch",
  "item.minecraft.cooked_rabbit": "Gebrode Kanéngchen",
  "item.minecraft.cooked_salmon": "Gebrodene Saumon",
  "item.minecraft.cookie": "Kichelchen",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Kofferbarren",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Kofferspeer",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kou-Spawn-Ee",
  "item.minecraft.creaking_spawn_egg": "Knarzenden-Spawn-Ee",
  "item.minecraft.creeper_banner_pattern": "Fändelvirlag",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Fändelmuster",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ee",
  "item.minecraft.crossbow": "Armbrust",
  "item.minecraft.crossbow.projectile": "Geschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Geschoss: %s× %s",
  "item.minecraft.crossbow.projectile.single": "Geschoss: %s",
  "item.minecraft.cyan_bundle": "Turquoise Bëndel",
  "item.minecraft.cyan_dye": "Turquoise Fuerfstoff",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Gefoer-Dëppeschierbel",
  "item.minecraft.danger_pottery_sherd": "Gefoer-Dëppeschierbel",
  "item.minecraft.dark_oak_boat": "Schwaarzeechenholzboot",
  "item.minecraft.dark_oak_chest_boat": "Schwaarzeechenholzboot mat Këscht",
  "item.minecraft.debug_stick": "Debug-Staf",
  "item.minecraft.debug_stick.empty": "%s huet keng Blockzoustänn",
  "item.minecraft.debug_stick.select": "'%s' ausgewielt (%s)",
  "item.minecraft.debug_stick.update": "'%s' ass elo %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantaaxt",
  "item.minecraft.diamond_boots": "Diamantstiwwelen",
  "item.minecraft.diamond_chestplate": "Diamantbroschtpanzer",
  "item.minecraft.diamond_helmet": "Diamanthelm",
  "item.minecraft.diamond_hoe": "Diamantheel",
  "item.minecraft.diamond_horse_armor": "Diamante Päerdsrüstung",
  "item.minecraft.diamond_leggings": "Diamantbeeschutz",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamantpickaaxt",
  "item.minecraft.diamond_shovel": "Diamantschëpp",
  "item.minecraft.diamond_spear": "Diamantspeer",
  "item.minecraft.diamond_sword": "Diamantschwäert",
  "item.minecraft.disc_fragment_5": "Schallplattefragment",
  "item.minecraft.disc_fragment_5.desc": "Schallplack - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ee",
  "item.minecraft.donkey_spawn_egg": "Iesel-Spawn-Ee",
  "item.minecraft.dragon_breath": "Draachenotem",
  "item.minecraft.dried_kelp": "Gedréchent Alg",
  "item.minecraft.drowned_spawn_egg": "Erdronkenen-Spawn-Ee",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungsbesaz",
  "item.minecraft.echo_shard": "Echoschierbel",
  "item.minecraft.egg": "Ee",
  "item.minecraft.elder_guardian_spawn_egg": "Grousswiechter-Spawn-Ee",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Verzaubert Buch",
  "item.minecraft.enchanted_golden_apple": "Verzauberte gëllenen Apel",
  "item.minecraft.end_crystal": "Endkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdraachen-Spawn-Ee",
  "item.minecraft.ender_eye": "Endera",
  "item.minecraft.ender_pearl": "Enderpärel",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ee",
  "item.minecraft.endermite_spawn_egg": "Endermite-Spawn-Ee",
  "item.minecraft.evoker_spawn_egg": "Magier-Spawn-Ee",
  "item.minecraft.experience_bottle": "Erfarungsfläsch",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Dëppeschierbel",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Dëppeschierbel",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Aen-Rüstungsbesaz",
  "item.minecraft.feather": "Fieder",
  "item.minecraft.fermented_spider_eye": "Fermentéiert Spannena",
  "item.minecraft.field_masoned_banner_pattern": "Mauerung-Fändelmuster",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Feierkugel",
  "item.minecraft.firework_rocket": "Feierwierksrakéit",
  "item.minecraft.firework_rocket.flight": "Fluchdauer:",
  "item.minecraft.firework_rocket.multiple_stars": "%s× %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feierwierksstär",
  "item.minecraft.firework_star.black": "Schwaarz",
  "item.minecraft.firework_star.blue": "Blo",
  "item.minecraft.firework_star.brown": "Brong",
  "item.minecraft.firework_star.custom_color": "Benotzerdefinéiert",
  "item.minecraft.firework_star.cyan": "Turquoise",
  "item.minecraft.firework_star.fade_to": "Iwwergang zu",
  "item.minecraft.firework_star.flicker": "Fonkelen",
  "item.minecraft.firework_star.gray": "Gro",
  "item.minecraft.firework_star.green": "Gréng",
  "item.minecraft.firework_star.light_blue": "Hellblo",
  "item.minecraft.firework_star.light_gray": "Hellgro",
  "item.minecraft.firework_star.lime": "Hellgréng",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Mof",
  "item.minecraft.firework_star.red": "Rout",
  "item.minecraft.firework_star.shape": "Onbekannt Form",
  "item.minecraft.firework_star.shape.burst": "Explosioun",
  "item.minecraft.firework_star.shape.creeper": "Creeperfërmeg",
  "item.minecraft.firework_star.shape.large_ball": "Grouss Kugel",
  "item.minecraft.firework_star.shape.small_ball": "Kleng Kugel",
  "item.minecraft.firework_star.shape.star": "Stärefërmeg",
  "item.minecraft.firework_star.trail": "Schwief",
  "item.minecraft.firework_star.white": "Wäiss",
  "item.minecraft.firework_star.yellow": "Giel",
  "item.minecraft.fishing_rod": "Aangel",
  "item.minecraft.flint": "Feiersteen",
  "item.minecraft.flint_and_steel": "Briquet",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Floss-Rüstungsbesaz",
  "item.minecraft.flow_banner_pattern": "Fändelvirlag",
  "item.minecraft.flow_banner_pattern.desc": "Floss",
  "item.minecraft.flow_banner_pattern.new": "Floss-Fändelmuster",
  "item.minecraft.flow_pottery_sherd": "Floss-Dëppeschierbel",
  "item.minecraft.flower_banner_pattern": "Fändelvirlag",
  "item.minecraft.flower_banner_pattern.desc": "Blumm",
  "item.minecraft.flower_banner_pattern.new": "Blummen-Fändelmuster",
  "item.minecraft.flower_pot": "Blummendëppen",
  "item.minecraft.fox_spawn_egg": "Fuuss-Spawn-Ee",
  "item.minecraft.friend_pottery_shard": "Frënd-Dëppeschierbel",
  "item.minecraft.friend_pottery_sherd": "Frënd-Dëppeschierbel",
  "item.minecraft.frog_spawn_egg": "Fräsch-Spawn-Ee",
  "item.minecraft.furnace_minecart": "Ugedriwwene Buggi",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ee",
  "item.minecraft.ghast_tear": "Ghast-Tréin",
  "item.minecraft.glass_bottle": "Glasfläsch",
  "item.minecraft.glistering_melon_slice": "Blénkeg Melounescheif",
  "item.minecraft.globe_banner_pattern": "Fändelvirlag",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Äerdball-Fändelmuster",
  "item.minecraft.glow_berries": "Liichtbieren",
  "item.minecraft.glow_ink_sac": "Liichttëntesak",
  "item.minecraft.glow_item_frame": "Liichtkader",
  "item.minecraft.glow_squid_spawn_egg": "Glousen Tëntefësch-Spawn-Ee",
  "item.minecraft.glowstone_dust": "Liichtsteestëbs",
  "item.minecraft.goat_horn": "Geessehar",
  "item.minecraft.goat_spawn_egg": "Geessen-Spawn-Ee",
  "item.minecraft.gold_ingot": "Goldbarren",
  "item.minecraft.gold_nugget": "Goldklompen",
  "item.minecraft.golden_apple": "Gëllenen Apel",
  "item.minecraft.golden_axe": "Goldaaxt",
  "item.minecraft.golden_boots": "Goldstiwwelen",
  "item.minecraft.golden_carrot": "Gëlle Muert",
  "item.minecraft.golden_chestplate": "Goldbroschtpanzer",
  "item.minecraft.golden_helmet": "Goldhelm",
  "item.minecraft.golden_hoe": "Goldheel",
  "item.minecraft.golden_horse_armor": "Gëlle Päerdsrüstung",
  "item.minecraft.golden_leggings": "Goldbeeschutz",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Goldpickaaxt",
  "item.minecraft.golden_shovel": "Goldschëpp",
  "item.minecraft.golden_spear": "Goldspeer",
  "item.minecraft.golden_sword": "Goldschwäert",
  "item.minecraft.gray_bundle": "Groe Bëndel",
  "item.minecraft.gray_dye": "Groe Fuerfstoff",
  "item.minecraft.gray_harness": "Gro Geschir",
  "item.minecraft.green_bundle": "Grénge Bëndel",
  "item.minecraft.green_dye": "Grénge Fuerfstoff",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Wiechter-Spawn-Ee",
  "item.minecraft.gunpowder": "Schéisspolver",
  "item.minecraft.guster_banner_pattern": "Fändelvirlag",
  "item.minecraft.guster_banner_pattern.desc": "Wandstoussert",
  "item.minecraft.guster_banner_pattern.new": "Wandstoussert-Fändelmuster",
  "item.minecraft.guster_pottery_sherd": "Wandstoussert-Dëppeschierbel",
  "item.minecraft.happy_ghast_spawn_egg": "Glécklechen-Ghast-Spawn-Ee",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Häerz vum Mier",
  "item.minecraft.heart_pottery_shard": "Häerz-Dëppeschierbel",
  "item.minecraft.heart_pottery_sherd": "Häerz-Dëppeschierbel",
  "item.minecraft.heartbreak_pottery_shard": "Häerzschmäerz-Dëppeschierbel",
  "item.minecraft.heartbreak_pottery_sherd": "Häerzschmäerz-Dëppeschierbel",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ee",
  "item.minecraft.honey_bottle": "Hunnegfläsch",
  "item.minecraft.honeycomb": "Hunnegwab",
  "item.minecraft.hopper_minecart": "Triichterbuggi",
  "item.minecraft.horse_spawn_egg": "Päerd-Spawn-Ee",
  "item.minecraft.host_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.host_armor_trim_smithing_template.new": "Restaurateur-Rüstungsbesaz",
  "item.minecraft.howl_pottery_shard": "Geheil-Dëppeschierbel",
  "item.minecraft.howl_pottery_sherd": "Geheil-Dëppeschierbel",
  "item.minecraft.husk_spawn_egg": "Wüstenzombie-Spawn-Ee",
  "item.minecraft.ink_sac": "Tëntesak",
  "item.minecraft.iron_axe": "Eisenaaxt",
  "item.minecraft.iron_boots": "Eisestiwwelen",
  "item.minecraft.iron_chestplate": "Eisebroschtpanzer",
  "item.minecraft.iron_golem_spawn_egg": "Eisegolem-Spawn-Ee",
  "item.minecraft.iron_helmet": "Eisenhelm",
  "item.minecraft.iron_hoe": "Eisenheel",
  "item.minecraft.iron_horse_armor": "Eise Päerdsrüstung",
  "item.minecraft.iron_ingot": "Eisebarren",
  "item.minecraft.iron_leggings": "Eisebeeschutz",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Eiseklompen",
  "item.minecraft.iron_pickaxe": "Eisepickaaxt",
  "item.minecraft.iron_shovel": "Eiseschëpp",
  "item.minecraft.iron_spear": "Eisespeer",
  "item.minecraft.iron_sword": "Eiseschwäert",
  "item.minecraft.item_frame": "Kader",
  "item.minecraft.jungle_boat": "Tropenholzboot",
  "item.minecraft.jungle_chest_boat": "Tropenholzboot mat Këscht",
  "item.minecraft.knowledge_book": "Buch vum Wëssen",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Lavaeemer",
  "item.minecraft.lead": "Léngt",
  "item.minecraft.leather": "Lieder",
  "item.minecraft.leather_boots": "Liedersstiwwelen",
  "item.minecraft.leather_chestplate": "Liedersjackett",
  "item.minecraft.leather_helmet": "Liederskap",
  "item.minecraft.leather_horse_armor": "Lieder Päerdsrüstung",
  "item.minecraft.leather_leggings": "Liedersbox",
  "item.minecraft.light_blue_bundle": "Hellbloe Bëndel",
  "item.minecraft.light_blue_dye": "Hellbloe Fuerfstoff",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Hellgroe Bëndel",
  "item.minecraft.light_gray_dye": "Hellgroe Fuerfstoff",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Hellgrénge Bëndel",
  "item.minecraft.lime_dye": "Hellgrénge Fuerfstoff",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Undauernden Dronk",
  "item.minecraft.lingering_potion.effect.awkward": "Komeschen undauernden Dronk",
  "item.minecraft.lingering_potion.effect.empty": "Net produzéierbaren undauernden Dronk",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Undauernden Dronk vun der Féierresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Undauernden Dronk vum Schued",
  "item.minecraft.lingering_potion.effect.healing": "Undauernden Dronk vun der Heelung",
  "item.minecraft.lingering_potion.effect.infested": "Undauernden Dronk vum Befal",
  "item.minecraft.lingering_potion.effect.invisibility": "Undauernden Dronk vun der Onsiichtbarkeet",
  "item.minecraft.lingering_potion.effect.leaping": "Undauernden Dronk vun der Sprongkraaft",
  "item.minecraft.lingering_potion.effect.levitation": "Undauernden Dronk vum Schwiewen",
  "item.minecraft.lingering_potion.effect.luck": "Undauernden Dronk vum Gléck",
  "item.minecraft.lingering_potion.effect.mundane": "Gewéinlechen undauernden Dronk",
  "item.minecraft.lingering_potion.effect.night_vision": "Undauernden Dronk vun der Nuechtsiicht",
  "item.minecraft.lingering_potion.effect.oozing": "Undauernden Dronk vum Schleimen",
  "item.minecraft.lingering_potion.effect.poison": "Undauernden Dronk vum Gëft",
  "item.minecraft.lingering_potion.effect.regeneration": "Undauernden Dronk vun der Regeneratioun",
  "item.minecraft.lingering_potion.effect.slow_falling": "Undauernden Dronk vum luese Fall",
  "item.minecraft.lingering_potion.effect.slowness": "Undauernden Dronk vun der Luesheet",
  "item.minecraft.lingering_potion.effect.strength": "Undauernden Dronk vun der Kraaft",
  "item.minecraft.lingering_potion.effect.swiftness": "Undauernden Dronk vun der Schnellegkeet",
  "item.minecraft.lingering_potion.effect.thick": "Déckflëssegen undauernden Dronk",
  "item.minecraft.lingering_potion.effect.turtle_master": "Undauernden Dronk vum Schildkrötenmeeschter",
  "item.minecraft.lingering_potion.effect.water": "Verbleiwend Waasserfläsch",
  "item.minecraft.lingering_potion.effect.water_breathing": "Undauernden Dronk vun der Waasserootmung",
  "item.minecraft.lingering_potion.effect.weakness": "Undauernden Dronk vun der Schwächt",
  "item.minecraft.lingering_potion.effect.weaving": "Undauernden Dronk vum Wiewen",
  "item.minecraft.lingering_potion.effect.wind_charged": "Undauernden Dronk vum Wandstouss",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ee",
  "item.minecraft.lodestone_compass": "Leetsteen-Kompass",
  "item.minecraft.mace": "Sträitkolben",
  "item.minecraft.magenta_bundle": "Magenta Bëndel",
  "item.minecraft.magenta_dye": "Magenta Fuerfstoff",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magmacrème",
  "item.minecraft.magma_cube_spawn_egg": "Magmawierfel-Spawn-Ee",
  "item.minecraft.mangrove_boat": "Mangrouwenholzboot",
  "item.minecraft.mangrove_chest_boat": "Mangrouwenholzboot mat Këscht",
  "item.minecraft.map": "Eidel Kaart",
  "item.minecraft.melon_seeds": "Melounekären",
  "item.minecraft.melon_slice": "Melounescheif",
  "item.minecraft.milk_bucket": "Mëllecheemer",
  "item.minecraft.minecart": "Buggi",
  "item.minecraft.miner_pottery_shard": "Minnet-Dëppeschierbel",
  "item.minecraft.miner_pottery_sherd": "Minnet-Dëppeschierbel",
  "item.minecraft.mojang_banner_pattern": "Fändelvirlag",
  "item.minecraft.mojang_banner_pattern.desc": "Déngen",
  "item.minecraft.mojang_banner_pattern.new": "Dengens-Fändelmuster",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ee",
  "item.minecraft.mourner_pottery_shard": "Wimmerer-Dëppeschierbel",
  "item.minecraft.mourner_pottery_sherd": "Wimmerer-Dëppeschierbel",
  "item.minecraft.mule_spawn_egg": "Mauliesel-Spawn-Ee",
  "item.minecraft.mushroom_stew": "Champignonszopp",
  "item.minecraft.music_disc_11": "Schallplack",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schallplack",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schallplack",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schallplack",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schallplack",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schallplack",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schallplack",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schallplack",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Schallplack",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplack",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schallplack",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schallplack",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schallplack",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schallplack",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schallplack",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Percipice",
  "item.minecraft.music_disc_relic": "Schallplack",
  "item.minecraft.music_disc_relic.desc": "Aaron Cberof - Relic",
  "item.minecraft.music_disc_stal": "Schallplack",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schallplack",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schallplack",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schallplack",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Réit Hämmelsfleesch",
  "item.minecraft.name_tag": "Schëld mam Numm",
  "item.minecraft.nautilus_shell": "Nautilusschuel",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ee",
  "item.minecraft.nether_brick": "Netherzill",
  "item.minecraft.nether_star": "Netherstär",
  "item.minecraft.nether_wart": "Netherwaarzel",
  "item.minecraft.netherite_axe": "Netheritaaxt",
  "item.minecraft.netherite_boots": "Netheritstiwwelen",
  "item.minecraft.netherite_chestplate": "Netheritebroschtpanzer",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netheriteheel",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netheritbarren",
  "item.minecraft.netherite_leggings": "Netheritbeeschutz",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheritepickaaxt",
  "item.minecraft.netherite_scrap": "Netheritfragment",
  "item.minecraft.netherite_shovel": "Netheritschëpp",
  "item.minecraft.netherite_spear": "Netheritspeer",
  "item.minecraft.netherite_sword": "Netheritschwäert",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmaddschabloun",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritopwäertung",
  "item.minecraft.oak_boat": "Eechenholzboot",
  "item.minecraft.oak_chest_boat": "Eecheboot mat Këscht",
  "item.minecraft.ocelot_spawn_egg": "Ozelot-Spawn-Ee",
  "item.minecraft.ominous_bottle": "Onheilvoll Fläsch",
  "item.minecraft.ominous_trial_key": "Onheilvolle Préifungsschlëssel",
  "item.minecraft.orange_bundle": "Orange Bëndel",
  "item.minecraft.orange_dye": "Orange Fuerfstoff",
  "item.minecraft.orange_harness": "Orange Geschier",
  "item.minecraft.painting": "Bild",
  "item.minecraft.pale_oak_boat": "Blatzeechenholzboot",
  "item.minecraft.pale_oak_chest_boat": "Blatzeechenholzboot mat Këscht",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ee",
  "item.minecraft.paper": "Pabeier",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Papagei-Spawn-Ee",
  "item.minecraft.phantom_membrane": "Phantomhaut",
  "item.minecraft.phantom_spawn_egg": "Phantom-Spawn-Ee",
  "item.minecraft.pig_spawn_egg": "Schwäin-Spawn-Ee",
  "item.minecraft.piglin_banner_pattern": "Fändelvirlag",
  "item.minecraft.piglin_banner_pattern.desc": "Schnëss",
  "item.minecraft.piglin_banner_pattern.new": "Schnëss-Fändelmuster",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbaren-Spawn-Ee",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ee",
  "item.minecraft.pillager_spawn_egg": "Plëmmert-Spawn-Ee",
  "item.minecraft.pink_bundle": "Rosae Bëndel",
  "item.minecraft.pink_dye": "Rosa Fuerfstoff",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Kaneplanz",
  "item.minecraft.pitcher_pod": "Kaneplanzekapsel",
  "item.minecraft.plenty_pottery_shard": "Räichtums-Dëppeschierbel",
  "item.minecraft.plenty_pottery_sherd": "Räichtum-Dëppeschierbel",
  "item.minecraft.poisonous_potato": "Vergëfte Gromper",
  "item.minecraft.polar_bear_spawn_egg": "Äisbier-Spawn-Ee",
  "item.minecraft.popped_chorus_fruit": "Geplatzte Chorusfruucht",
  "item.minecraft.porkchop": "Réit Schwéngefleesch",
  "item.minecraft.potato": "Gromper",
  "item.minecraft.potion": "Dronk",
  "item.minecraft.potion.effect.awkward": "Komeschen Dronk",
  "item.minecraft.potion.effect.empty": "Net produzéierbaren Dronk",
  "item.minecraft.potion.effect.fire_resistance": "Dronk vun der Féierresistenz",
  "item.minecraft.potion.effect.harming": "Dronk vum Schued",
  "item.minecraft.potion.effect.healing": "Dronk vun der Heelung",
  "item.minecraft.potion.effect.infested": "Dronk vum Befal",
  "item.minecraft.potion.effect.invisibility": "Dronk vun der Onsiichtbarkeet",
  "item.minecraft.potion.effect.leaping": "Dronk vun der Sprongkraaft",
  "item.minecraft.potion.effect.levitation": "Dronk vum Schwiewen",
  "item.minecraft.potion.effect.luck": "Dronk vum Gléck",
  "item.minecraft.potion.effect.mundane": "Gewéinlechen Dronk",
  "item.minecraft.potion.effect.night_vision": "Dronk vun der Nuechtsiicht",
  "item.minecraft.potion.effect.oozing": "Dronk vum Schleimen",
  "item.minecraft.potion.effect.poison": "Dronk vum Gëft",
  "item.minecraft.potion.effect.regeneration": "Dronk vun der Regeneratioun",
  "item.minecraft.potion.effect.slow_falling": "Dronk vum luese Fall",
  "item.minecraft.potion.effect.slowness": "Dronk vun der Luesheet",
  "item.minecraft.potion.effect.strength": "Dronk vun der Kraaft",
  "item.minecraft.potion.effect.swiftness": "Dronk vun der Schnellegkeet",
  "item.minecraft.potion.effect.thick": "Déckflëssegen Dronk",
  "item.minecraft.potion.effect.turtle_master": "Dronk vum Schildkrötenmeeschter",
  "item.minecraft.potion.effect.water": "Waasserfläsch",
  "item.minecraft.potion.effect.water_breathing": "Dronk vun der Waasserootmung",
  "item.minecraft.potion.effect.weakness": "Dronk vun der Schwächt",
  "item.minecraft.potion.effect.weaving": "Dronk vum Wiewen",
  "item.minecraft.potion.effect.wind_charged": "Dronk vum Wandstouss",
  "item.minecraft.pottery_shard_archer": "Schëtzen-Dëppeschierbel",
  "item.minecraft.pottery_shard_arms_up": "Gebärden-Dëppeschierbel",
  "item.minecraft.pottery_shard_prize": "Edelsteen-Dëppeschierbel",
  "item.minecraft.pottery_shard_skull": "Doudekapp-Dëppeschierbel",
  "item.minecraft.powder_snow_bucket": "Polverschnéieemer",
  "item.minecraft.prismarine_crystals": "Prismarinkristall",
  "item.minecraft.prismarine_shard": "Prismarinschierbel",
  "item.minecraft.prize_pottery_shard": "Edelsteen-Dëppeschierbel",
  "item.minecraft.prize_pottery_sherd": "Edelsteen-Dëppeschierbel",
  "item.minecraft.pufferfish": "Kugelfësch",
  "item.minecraft.pufferfish_bucket": "Kugelfëscheemer",
  "item.minecraft.pufferfish_spawn_egg": "Kugelfësch-Spawn-Ee",
  "item.minecraft.pumpkin_pie": "Kürbiskuch",
  "item.minecraft.pumpkin_seeds": "Kürbiskären",
  "item.minecraft.purple_bundle": "Mofe Bëndel",
  "item.minecraft.purple_dye": "Mofe Fuerfstoff",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Réi Kanéngchen",
  "item.minecraft.rabbit_foot": "Kanéngecherspatt",
  "item.minecraft.rabbit_hide": "Kanéngecherspelz",
  "item.minecraft.rabbit_spawn_egg": "Kanéngchen-Spawn-Ee",
  "item.minecraft.rabbit_stew": "Kanéngechersragoût",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Opzéier-Rüstungsbesaz",
  "item.minecraft.ravager_spawn_egg": "Verwüster-Spawn-Ee",
  "item.minecraft.raw_copper": "Réikoffer",
  "item.minecraft.raw_gold": "Réigold",
  "item.minecraft.raw_iron": "Réieisen",
  "item.minecraft.recovery_compass": "Rettungskompass",
  "item.minecraft.red_bundle": "Roude Bëndel",
  "item.minecraft.red_dye": "Roude Fuerfstoff",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone-Stëbs",
  "item.minecraft.resin_brick": "Harzzill",
  "item.minecraft.resin_clump": "Harzklompen",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rëppen-Rüstungsbesaz",
  "item.minecraft.rotten_flesh": "Verfaultent Fleesch",
  "item.minecraft.saddle": "Suedel",
  "item.minecraft.salmon": "Réie Saumon",
  "item.minecraft.salmon_bucket": "Saumoneemer",
  "item.minecraft.salmon_spawn_egg": "Saumon-Spawn-Ee",
  "item.minecraft.scrape_pottery_sherd": "Schréibs-Deppeschierbel",
  "item.minecraft.scute": "Schupp",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wachen-Rüstungsbesaz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Gestalter-Rüstungsbesaz",
  "item.minecraft.sheaf_pottery_shard": "Garben-Dëppeschierbel",
  "item.minecraft.sheaf_pottery_sherd": "Garben-Dëppeschierbel",
  "item.minecraft.shears": "Schéier",
  "item.minecraft.sheep_spawn_egg": "Schof-Spawn-Ee",
  "item.minecraft.shelter_pottery_shard": "Zouflocht-Dëppeschierbel",
  "item.minecraft.shelter_pottery_sherd": "Zouflocht-Dëppeschierbel",
  "item.minecraft.shield": "Schëld",
  "item.minecraft.shield.black": "Schwaarzt Schëld",
  "item.minecraft.shield.blue": "Blot Schëld",
  "item.minecraft.shield.brown": "Brongt Schëld",
  "item.minecraft.shield.cyan": "Turquoiset Schëld",
  "item.minecraft.shield.gray": "Grot Schëld",
  "item.minecraft.shield.green": "Gréngt Schëld",
  "item.minecraft.shield.light_blue": "Hellblot Schëld",
  "item.minecraft.shield.light_gray": "Hellgrot Schëld",
  "item.minecraft.shield.lime": "Hellgréngt Schëld",
  "item.minecraft.shield.magenta": "Magentat Schëld",
  "item.minecraft.shield.orange": "Oranget Schëld",
  "item.minecraft.shield.pink": "Rosat Schëld",
  "item.minecraft.shield.purple": "Moft Schëld",
  "item.minecraft.shield.red": "Rout Schëld",
  "item.minecraft.shield.white": "Wäisst Schëld",
  "item.minecraft.shield.yellow": "Gielt Schëld",
  "item.minecraft.shulker_shell": "Shulker-Schuel",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ee",
  "item.minecraft.sign": "Zeechen",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stëll-Rüstungsbesaz",
  "item.minecraft.silverfish_spawn_egg": "Sëlwerfëschelchen-Spawn-Ee",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettpäerd-Spawn-Ee",
  "item.minecraft.skeleton_spawn_egg": "Skelett-Spawn-Ee",
  "item.minecraft.skull_banner_pattern": "Fändelvirlag",
  "item.minecraft.skull_banner_pattern.desc": "Doudekapp",
  "item.minecraft.skull_banner_pattern.new": "Doudekapp-Fändelmuster",
  "item.minecraft.skull_pottery_shard": "Doudekapp-Dëppeschierbel",
  "item.minecraft.skull_pottery_sherd": "Doudekapp-Dëppeschierbel",
  "item.minecraft.slime_ball": "Schläimball",
  "item.minecraft.slime_spawn_egg": "Schläim-Spawn-Ee",
  "item.minecraft.smithing_template": "Schmaddschabloun",
  "item.minecraft.smithing_template.applies_to": "Uwennbar op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Barren oder Kristall bäimaachen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsdeel bäimachen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barren & Kristaller",
  "item.minecraft.smithing_template.ingredients": "Wierkstoffer:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherritbarre bäimaachen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantenausrüstung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstungsdeel, Geschier oder Schwäert aus Diamant bäimachen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritbarren",
  "item.minecraft.smithing_template.upgrade": "Opwäerten: ",
  "item.minecraft.sniffer_spawn_egg": "Schnoffeler-Spawn-Ee",
  "item.minecraft.snort_pottery_shard": "Schnaub-Dëppeschierbel",
  "item.minecraft.snort_pottery_sherd": "Schnaub-Dëppeschierbel",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnëss-Rüstungsbesaz",
  "item.minecraft.snow_golem_spawn_egg": "Schnéigolem-Spawn-Ee",
  "item.minecraft.snowball": "Schnéiball",
  "item.minecraft.spectral_arrow": "Spektral Feil",
  "item.minecraft.spider_eye": "Spannena",
  "item.minecraft.spider_spawn_egg": "Spann-Spawn-Ee",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Tuermspëtzten-Rüstungsbesaz",
  "item.minecraft.splash_potion": "Worfdronk",
  "item.minecraft.splash_potion.effect.awkward": "Komesche Worfdronk",
  "item.minecraft.splash_potion.effect.empty": "Net produzéierbare Worfdronk",
  "item.minecraft.splash_potion.effect.fire_resistance": "Worfdronk vun der Féierresistenz",
  "item.minecraft.splash_potion.effect.harming": "Worfdronk vum Schued",
  "item.minecraft.splash_potion.effect.healing": "Worfdronk vun der Waasserootmung",
  "item.minecraft.splash_potion.effect.infested": "Worfdronk vum Befal",
  "item.minecraft.splash_potion.effect.invisibility": "Worfdronk vun der Onsiichtbarkeet",
  "item.minecraft.splash_potion.effect.leaping": "Worfdronk vun der Sprongkraaft",
  "item.minecraft.splash_potion.effect.levitation": "Worfdronk vum Schwiewen",
  "item.minecraft.splash_potion.effect.luck": "Worfdronk vum Gléck",
  "item.minecraft.splash_potion.effect.mundane": "Gewéinleche Worfdronk",
  "item.minecraft.splash_potion.effect.night_vision": "Worfdronk vun der Nuechtsiicht",
  "item.minecraft.splash_potion.effect.oozing": "Worfdronk vum Schleimen",
  "item.minecraft.splash_potion.effect.poison": "Worfdronk vum Gëft",
  "item.minecraft.splash_potion.effect.regeneration": "Worfdronk vun der Regeneratioun",
  "item.minecraft.splash_potion.effect.slow_falling": "Worfdronk vum luese Fall",
  "item.minecraft.splash_potion.effect.slowness": "Worfdronk vun der Luesheet",
  "item.minecraft.splash_potion.effect.strength": "Worfdronk vun der Kraaft",
  "item.minecraft.splash_potion.effect.swiftness": "Worfdronk vun der Schnellegkeet",
  "item.minecraft.splash_potion.effect.thick": "Déckflëssege Worfdronk",
  "item.minecraft.splash_potion.effect.turtle_master": "Worfdronk vum Schildkrötenmeeschter",
  "item.minecraft.splash_potion.effect.water": "Werfbar Waasserfläsch",
  "item.minecraft.splash_potion.effect.water_breathing": "Worfdronk vun der Luesheet",
  "item.minecraft.splash_potion.effect.weakness": "Worfdronk vun der Schwächt",
  "item.minecraft.splash_potion.effect.weaving": "Worfdronk vum Wiewen",
  "item.minecraft.splash_potion.effect.wind_charged": "Worfdronk vum Wandstouss",
  "item.minecraft.spruce_boat": "Fiichtenholzboot",
  "item.minecraft.spruce_chest_boat": "Fiichtenholzboot mat Këscht",
  "item.minecraft.spyglass": "Spyglas",
  "item.minecraft.squid_spawn_egg": "Tëntefësch-Spawn-Ee",
  "item.minecraft.stick": "Bengel",
  "item.minecraft.stone_axe": "Steeaaxt",
  "item.minecraft.stone_hoe": "Steenheel",
  "item.minecraft.stone_pickaxe": "Steepickaaxt",
  "item.minecraft.stone_shovel": "Steeschëpp",
  "item.minecraft.stone_spear": "Steespeer",
  "item.minecraft.stone_sword": "Steeschwäert",
  "item.minecraft.stray_spawn_egg": "Vagabund-Spawn-Ee",
  "item.minecraft.strider_spawn_egg": "Schreiter-Spawn-Ee",
  "item.minecraft.string": "Fuedem",
  "item.minecraft.sugar": "Zocker",
  "item.minecraft.suspicious_stew": "Suspekt Zopp",
  "item.minecraft.sweet_berries": "Séissbieren",
  "item.minecraft.tadpole_bucket": "Kauzekappeemer",
  "item.minecraft.tadpole_spawn_egg": "Kauzekapp-Spawn-Ee",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeiten-Rüstungsbesaz",
  "item.minecraft.tipped_arrow": "Gedränkte Feil",
  "item.minecraft.tipped_arrow.effect.awkward": "Gedränkte Feil",
  "item.minecraft.tipped_arrow.effect.empty": "Net hierstellbare gedränkte Feil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Feil vun der Féierresistenz",
  "item.minecraft.tipped_arrow.effect.harming": "Feil vum Schued",
  "item.minecraft.tipped_arrow.effect.healing": "Feil vun der Heelung",
  "item.minecraft.tipped_arrow.effect.infested": "Feil vum Befal",
  "item.minecraft.tipped_arrow.effect.invisibility": "Feil vun der Onsiichtbarkeet",
  "item.minecraft.tipped_arrow.effect.leaping": "Feil vun der Sprongkraaft",
  "item.minecraft.tipped_arrow.effect.levitation": "Feil vum Schwiewen",
  "item.minecraft.tipped_arrow.effect.luck": "Feil vum Gléck",
  "item.minecraft.tipped_arrow.effect.mundane": "Gedränkte Feil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Feil vun der Nuechtsiicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Feil vum Schläimen",
  "item.minecraft.tipped_arrow.effect.poison": "Feil vum Gëft",
  "item.minecraft.tipped_arrow.effect.regeneration": "Feil vun der Regeneratioun",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Feil vum luese Fall",
  "item.minecraft.tipped_arrow.effect.slowness": "Feil vun der Luesheet",
  "item.minecraft.tipped_arrow.effect.strength": "Feil vun der Kraaft",
  "item.minecraft.tipped_arrow.effect.swiftness": "Feil vun der Schnellegkeet",
  "item.minecraft.tipped_arrow.effect.thick": "Gedränkte Feil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Feil vum Schildkrötenmeeschter",
  "item.minecraft.tipped_arrow.effect.water": "Naasse Feil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Feil vun der Waasserootmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Feil vun der Schwächt",
  "item.minecraft.tipped_arrow.effect.weaving": "Feil vum Wiewen",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Feil vum Wandstouss",
  "item.minecraft.tnt_minecart": "TNT-Buggi",
  "item.minecraft.torchflower_seeds": "Karblumm Som",
  "item.minecraft.totem_of_undying": "Totem vun der Onstierflechkeet",
  "item.minecraft.trader_llama_spawn_egg": "Händlerlama-Spawn-Ee",
  "item.minecraft.trial_key": "Préifungsschlëssel",
  "item.minecraft.trident": "Dräizack",
  "item.minecraft.tropical_fish": "Tropefësch",
  "item.minecraft.tropical_fish_bucket": "Tropefëscheemer",
  "item.minecraft.tropical_fish_spawn_egg": "Tropefësch-Spawn-Ee",
  "item.minecraft.turtle_helmet": "Schildkrötenpanzer",
  "item.minecraft.turtle_scute": "Schildkröte-Schupp",
  "item.minecraft.turtle_spawn_egg": "Schildkröten-Spawn-Ee",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plogegeescht-Rüstungsbesaz",
  "item.minecraft.vex_spawn_egg": "Plogeeschter-Spawn-Ee",
  "item.minecraft.villager_spawn_egg": "Awunner-Spawn-Ee",
  "item.minecraft.vindicator_spawn_egg": "Lakai-Spawn-Ee",
  "item.minecraft.wandering_trader_spawn_egg": "Nomadenhändler-Spawn-Ee",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Wart-Rüstungsbesaz",
  "item.minecraft.warden_spawn_egg": "Wärter-Spawn-Ee",
  "item.minecraft.warped_fungus_on_a_stick": "Verduerwene Champignon op engem Bengel",
  "item.minecraft.water_bucket": "Waassereemer",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Weefanner-Rüstungsbesaz",
  "item.minecraft.wheat": "Weess",
  "item.minecraft.wheat_seeds": "Weesskären",
  "item.minecraft.white_bundle": "Wäisse Bëndel",
  "item.minecraft.white_dye": "Wäisse Fuerfstoff",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmaddschabloun",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wildnis-Rüstungsbesaz",
  "item.minecraft.wind_charge": "Wandstouss",
  "item.minecraft.witch_spawn_egg": "Hexen-Spawn-Ee",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither-Skelett-Spawn-Ee",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Ee",
  "item.minecraft.wolf_armor": "Wollefsspanzer",
  "item.minecraft.wolf_spawn_egg": "Wollefs-Spawn-Ee",
  "item.minecraft.wooden_axe": "Holzaaxt",
  "item.minecraft.wooden_hoe": "Holzheel",
  "item.minecraft.wooden_pickaxe": "Holzpickaaxt",
  "item.minecraft.wooden_shovel": "Holzschëpp",
  "item.minecraft.wooden_spear": "Holzspeer",
  "item.minecraft.wooden_sword": "Holzschwäert",
  "item.minecraft.writable_book": "Buch a Fieder",
  "item.minecraft.written_book": "Beschriwwent Buch",
  "item.minecraft.yellow_bundle": "Giele Bëndel",
  "item.minecraft.yellow_dye": "Giele Fuerfstoff",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ee",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiepäerd-Spawn-Ee",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Ee",
  "item.minecraft.zombie_villager_spawn_egg": "Zombieawunner-Spawn-Ee",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizéierten-Piglin-Spawn-Ee"
}
export const lb_lu = items; 
